const dictionaryData = [
 {
   "latin": "ἀγαθός, -ή, -όν",
   "info": "",
   "definitions": ["goed"],
   "chapter": 21,
   "searchForm": "agathos, -e, -on"
 },
 {
   "latin": "ἄγαν",
   "info": "bijw",
   "definitions": ["teveel"],
   "chapter": 42,
   "searchForm": "agan"
 },
 {
   "latin": "ἀγανακτέω",
   "info": "",
   "definitions": ["boos worden, boos zijn"],
   "chapter": 11,
   "searchForm": "aganakteo"
 },
 {
   "latin": "ἀγγέλλω",
   "info": "",
   "definitions": ["berichten"],
   "chapter": 19,
   "searchForm": "aggello"
 },
 {
   "latin": "ἀγείρω",
   "info": "",
   "definitions": ["verzamelen, bijeenroepen"],
   "chapter": 28,
   "searchForm": "ageiro"
 },
 {
   "latin": "ἀγνοέω",
   "info": "",
   "definitions": ["niet begrijpen, niet weten"],
   "chapter": 17,
   "searchForm": "agnoeo"
 },
 {
   "latin": "ἡ ἀγορά",
   "info": "",
   "definitions": ["markt"],
   "chapter": 19,
   "searchForm": "agora"
 },
 {
   "latin": "ὁ ἀγρός",
   "info": "",
   "definitions": ["veld, akker"],
   "chapter": 38,
   "searchForm": "agros"
 },
 {
   "latin": "ἄγω",
   "info": "",
   "definitions": ["leiden, brengen"],
   "chapter": 3,
   "searchForm": "ago"
 },
 {
   "latin": "ὁ ἀγών, ἀγῶνος",
   "info": "",
   "definitions": ["wedstrijd, strijd"],
   "chapter": 31,
   "searchForm": "agon, agonos"
 },
 {
   "latin": "ἀγωνίζομαι",
   "info": "",
   "definitions": ["strijden, een wedstrijd houden (tegen)"],
   "chapter": 31,
   "searchForm": "agonizomai"
 },
 {
   "latin": "ἡ ἀδελφή",
   "info": "",
   "definitions": ["zus"],
   "chapter": 4,
   "searchForm": "adelfe"
 },
 {
   "latin": "ὁ ἀδελφός",
   "info": "",
   "definitions": ["broer"],
   "chapter": 4,
   "searchForm": "adelfos"
 },
 {
   "latin": "ἄδικος, -ον",
   "info": "",
   "definitions": ["onrechtvaardig"],
   "chapter": 27,
   "searchForm": "adikos, -on"
 },
 {
   "latin": "ἀδύνατος, -ον",
   "info": "",
   "definitions": ["niet in staat", "onmogelijk"],
   "chapter": 26,
   "searchForm": "adunatos, -on"
 },
 {
   "latin": "ἀεί",
   "info": "bijw",
   "definitions": ["altijd, steeds"],
   "chapter": 3,
   "searchForm": "aei"
 },
 {
   "latin": "αἱ Ἀθῆναι",
   "info": "",
   "definitions": ["(de stad) Athene"],
   "chapter": 19,
   "searchForm": "Athenai"
 },
 {
   "latin": "ὁ Ἀθηναῖος",
   "info": "",
   "definitions": ["Athener"],
   "chapter": 19,
   "searchForm": "athenaios"
 },
 {
   "latin": "ἄθλιος, -α, -ον",
   "info": "",
   "definitions": ["ongelukkig"],
   "chapter": 21,
   "searchForm": "athlios, -a, -on"
 },
 {
   "latin": "τὸ ἆθλον",
   "info": "",
   "definitions": ["(wedstrijs)prijs"],
   "chapter": 34,
   "searchForm": "athlon"
 },
 {
   "latin": "ᾄδω",
   "info": "",
   "definitions": ["(be)zingen"],
   "chapter": 23,
   "searchForm": "aido"
 },
 {
   "latin": "αἴρω",
   "info": "",
   "definitions": ["optillen"],
   "chapter": 32,
   "searchForm": "airo"
 },
 {
   "latin": "αἰσθάνομαι",
   "info": "",
   "definitions": ["waarnemen, (be)merken"],
   "chapter": 36,
   "searchForm": "aisthanomai"
 },
 {
   "latin": "αἰσχρός, -ά, -όν",
   "info": "",
   "definitions": ["lelijk, schandelijk"],
   "chapter": 21,
   "searchForm": "aischros, -a, -on"
 },
 {
   "latin": "ἡ αἰσχύνη",
   "info": "",
   "definitions": ["schande"],
   "chapter": 38,
   "searchForm": "aischune"
 },
 {
   "latin": "αἰτέω",
   "info": "(+ acc + acc)",
   "definitions": ["(iemand om iets) vragen, eisen"],
   "chapter": 31,
   "searchForm": "aiteo"
 },
 {
   "latin": "αἰτιάομαι",
   "info": "",
   "definitions": ["beschuldigen"],
   "chapter": 44,
   "searchForm": "aitiaomai"
 },
 {
   "latin": "ἀκολουθέω",
   "info": "+ dat",
   "definitions": ["volgen"],
   "chapter": 29,
   "searchForm": "akoloutheo"
 },
 {
   "latin": "ἀκούω",
   "info": "+ gen/acc",
   "definitions": ["luisteren (naar), horen"],
   "chapter": 11,
   "searchForm": "akouo"
 },
 {
   "latin": "ἀκριβής, -ές",
   "info": "",
   "definitions": ["nauwkeurig, precies"],
   "chapter": 37,
   "searchForm": "akribes, -es"
 },
 {
   "latin": "ἄκων, ἄκουσα, ἆκον, ἄκοντος ",
   "info": "",
   "definitions": ["onvrijwillig, tegen de zin"],
   "chapter": 26,
   "searchForm": "akon, akousa, akon, akontos "
 },
 {
   "latin": "ἡ ἀλήθεια",
   "info": "",
   "definitions": ["de waarheid"],
   "chapter": 17,
   "searchForm": "aletheia"
 },
 {
   "latin": "ἀληθής, -ές",
   "info": "",
   "definitions": ["echt, waar, werkelijk"],
   "chapter": 37,
   "searchForm": "alethes, -es"
 },
 {
   "latin": "ἀλλ’ ",
   "info": "",
   "definitions": ["maar"],
   "chapter": 3,
   "searchForm": "all’ "
 },
 {
   "latin": "ἀλλά",
   "info": "",
   "definitions": ["maar"],
   "chapter": 3,
   "searchForm": "alla"
 },
 {
   "latin": "ἀλλήλων, -οις, -ους",
   "info": "mv",
   "definitions": ["elkaar"],
   "chapter": 24,
   "searchForm": "allelon, -ois, -ous"
 },
 {
   "latin": "ἄλλος, -η, -ο",
   "info": "",
   "definitions": ["ander, overig"],
   "chapter": 22,
   "searchForm": "allos, -e, -o"
 },
 {
   "latin": "ἆμα μή;",
   "info": "",
   "definitions": ["toch (zeker) niet?"],
   "chapter": 19,
   "searchForm": "ama me;"
 },
 {
   "latin": "ἀμείνων, -ον",
   "info": "",
   "definitions": ["beter"],
   "chapter": 42,
   "searchForm": "ameinon, -on"
 },
 {
   "latin": "ἀμύνομαι",
   "info": "(+ acc)",
   "definitions": ["zich verdedigen (tegen)"],
   "chapter": 32,
   "searchForm": "amunomai"
 },
 {
   "latin": "ἀμφότεροι, -αι, -α",
   "info": "mv",
   "definitions": ["beide"],
   "chapter": 37,
   "searchForm": "amfoteroi, -ai, -a"
 },
 {
   "latin": "ἄν",
   "info": "+ con",
   "definitions": ["*gebeurtenis in de toekomst*", "*algemeen of herhaald feit*"],
   "chapter": 41,
   "searchForm": "an"
 },
 {
   "latin": "ἄν",
   "info": "+ opt",
   "definitions": ["*mogelijkheid, waarschijnlijkheid*"],
   "chapter": 42,
   "searchForm": "an"
 },
 {
   "latin": "ἀν-",
   "info": "voorvoegsel",
   "definitions": ["omhoog-, -op"],
   "chapter": 26,
   "searchForm": "an-"
 },
 {
   "latin": "ἀνα-",
   "info": "voorvoegsel",
   "definitions": ["omhoog-, -op"],
   "chapter": 26,
   "searchForm": "ana-"
 },
 {
   "latin": "ἀναγιγνώσκω",
   "info": "",
   "definitions": ["herkennen"],
   "chapter": 19,
   "searchForm": "anagignosko"
 },
 {
   "latin": "ἀναγκάζω",
   "info": "",
   "definitions": ["noodzaken, dwingen"],
   "chapter": 33,
   "searchForm": "anagkazo"
 },
 {
   "latin": "ἀνάγω",
   "info": "",
   "definitions": ["omhoog leiden"],
   "chapter": 27,
   "searchForm": "anago"
 },
 {
   "latin": "ἀναιρέω",
   "info": "",
   "definitions": ["oppakken, opnemen"],
   "chapter": 38,
   "searchForm": "anaireo"
 },
 {
   "latin": "ἀνδρεῖος, -α, -ον",
   "info": "",
   "definitions": ["dapper"],
   "chapter": 21,
   "searchForm": "andreios, -a, -on"
 },
 {
   "latin": "ὁ ἄνεμος",
   "info": "",
   "definitions": ["wind"],
   "chapter": 31,
   "searchForm": "anemos"
 },
 {
   "latin": "ἄνευ",
   "info": "+ gen",
   "definitions": ["zonder"],
   "chapter": 43,
   "searchForm": "aneu"
 },
 {
   "latin": "ἀνέχομαι",
   "info": "",
   "definitions": ["uithouden, verdragen"],
   "chapter": 43,
   "searchForm": "anechomai"
 },
 {
   "latin": "ὁ ἀνήρ, ἀνδρός",
   "info": "",
   "definitions": ["man"],
   "chapter": 7,
   "searchForm": "aner, andros"
 },
 {
   "latin": "ἀνθ’",
   "info": "+ gen",
   "definitions": ["in ruil voor, in plaats van"],
   "chapter": 7,
   "searchForm": "anth’"
 },
 {
   "latin": "ὁ ἄνθρωπος ",
   "info": "",
   "definitions": ["mens"],
   "chapter": 2,
   "searchForm": "anthropos "
 },
 {
   "latin": "ἀνοίγω",
   "info": "",
   "definitions": ["openen"],
   "chapter": 32,
   "searchForm": "anoigo"
 },
 {
   "latin": "ἀντ’",
   "info": "+ gen",
   "definitions": ["in ruil voor, in plaats van"],
   "chapter": 7,
   "searchForm": "ant’"
 },
 {
   "latin": "ἀντί",
   "info": "+ gen",
   "definitions": ["in ruil voor, in plaats van"],
   "chapter": 7,
   "searchForm": "anti"
 },
 {
   "latin": "ἄνω",
   "info": "bijw",
   "definitions": ["omhoog, boven"],
   "chapter": 28,
   "searchForm": "ano"
 },
 {
   "latin": "ἄξιος, -α, -ον",
   "info": "+ gen",
   "definitions": ["(iets) waard, waardig"],
   "chapter": 34,
   "searchForm": "axios, -a, -on"
 },
 {
   "latin": "ἀπ’",
   "info": "+ gen",
   "definitions": ["van … vandaan, vanaf", "sinds"],
   "chapter": 12,
   "searchForm": "ap’"
 },
 {
   "latin": "ἀπατάω",
   "info": "",
   "definitions": ["bedriegen, misleiden"],
   "chapter": 28,
   "searchForm": "apatao"
 },
 {
   "latin": "ἄπειμι",
   "info": "",
   "definitions": ["afwezig zijn"],
   "chapter": 41,
   "searchForm": "apeimi"
 },
 {
   "latin": "ἀπό",
   "info": "+ gen",
   "definitions": ["van … vandaan, vanaf", "sinds"],
   "chapter": 12,
   "searchForm": "apo"
 },
 {
   "latin": "ἀπο-",
   "info": "voorvoegsel",
   "definitions": ["weg-, af-"],
   "chapter": 23,
   "searchForm": "apo-"
 },
 {
   "latin": "ἀπο-θνῄσκω",
   "info": "",
   "definitions": ["sterven, omkomen"],
   "chapter": 13,
   "searchForm": "apothneisko"
 },
 {
   "latin": "ἀποκρίνομαι",
   "info": "",
   "definitions": ["antwoorden"],
   "chapter": 36,
   "searchForm": "apokrinomai"
 },
 {
   "latin": "ἀπο-κτείνω",
   "info": "",
   "definitions": ["doden"],
   "chapter": 13,
   "searchForm": "apokteino"
 },
 {
   "latin": "ἀπολογέομαι",
   "info": "",
   "definitions": ["zich verdedigen"],
   "chapter": 44,
   "searchForm": "apologeomai"
 },
 {
   "latin": "ἀπορέω",
   "info": "",
   "definitions": ["in onzekerheid verkeren, zich geen raad weten"],
   "chapter": 39,
   "searchForm": "aporeo"
 },
 {
   "latin": "ἀποφαίνω",
   "info": "",
   "definitions": ["aantonen, bewijzen", "openbaar maken"],
   "chapter": 33,
   "searchForm": "apofaino"
 },
 {
   "latin": "ἆρ’ οὐ;",
   "info": "",
   "definitions": ["toch zeker, toch wel"],
   "chapter": 19,
   "searchForm": "ar’ ou;"
 },
 {
   "latin": "ἆρ’ οὐκ;",
   "info": "",
   "definitions": ["toch zeker, toch wel"],
   "chapter": 19,
   "searchForm": "ar’ ouk;"
 },
 {
   "latin": "ἆρα",
   "info": "",
   "definitions": ["*leidt vraagzin in; niet vertalen*"],
   "chapter": 14,
   "searchForm": "ara"
 },
 {
   "latin": "ἄρα",
   "info": "",
   "definitions": ["dus"],
   "chapter": 22,
   "searchForm": "ara"
 },
 {
   "latin": "τὸ ἀργύριον",
   "info": "",
   "definitions": ["zilver, geld"],
   "chapter": 37,
   "searchForm": "argurion"
 },
 {
   "latin": "ἀρέσκω",
   "info": "+ dat",
   "definitions": ["bevallen, in de smaak vallen bij"],
   "chapter": 37,
   "searchForm": "aresko"
 },
 {
   "latin": "ἡ ἀρετή",
   "info": "",
   "definitions": ["dapperheid, voortreffelijkheid"],
   "chapter": 7,
   "searchForm": "arete"
 },
 {
   "latin": "ἄριστος, -η, -ον",
   "info": "",
   "definitions": ["best"],
   "chapter": 23,
   "searchForm": "aristos, -e, -on"
 },
 {
   "latin": "ἡ ἀρχή",
   "info": "",
   "definitions": ["begin", "heerschappij, rijk"],
   "chapter": 17,
   "searchForm": "arche"
 },
 {
   "latin": "ἄρχω",
   "info": "",
   "definitions": ["beginnen", "**+ gen** heersen (over)"],
   "chapter": 27,
   "searchForm": "archo"
 },
 {
   "latin": "ὁ ἄρχων, ἄρχοντος",
   "info": "",
   "definitions": ["leider, heerser"],
   "chapter": 33,
   "searchForm": "archon, archontos"
 },
 {
   "latin": "ἡ ἀσπίς, ἀσπίδος",
   "info": "",
   "definitions": ["schild"],
   "chapter": 6,
   "searchForm": "aspis, aspidos"
 },
 {
   "latin": "τὸ ἄστυ, ἄστεως",
   "info": "",
   "definitions": ["stad (*de gebouwen*)"],
   "chapter": 42,
   "searchForm": "astu, asteos"
 },
 {
   "latin": "αὖθις",
   "info": "bijw",
   "definitions": ["opnieuw, weer"],
   "chapter": 32,
   "searchForm": "authis"
 },
 {
   "latin": "αὐξάνομαι",
   "info": "",
   "definitions": ["groeien"],
   "chapter": 34,
   "searchForm": "auxanomai"
 },
 {
   "latin": "αὐτῆς",
   "info": "",
   "definitions": ["van haar"],
   "chapter": 8,
   "searchForm": "autes"
 },
 {
   "latin": "αὐτίκα",
   "info": "bijw",
   "definitions": ["meteen"],
   "chapter": 3,
   "searchForm": "autika"
 },
 {
   "latin": "αὐτός, -ή, -όν",
   "info": "",
   "definitions": ["*αὐτός (ὁ)* zelf", "*ὁ αὐτός (καί)* dezelfde, hetzelfde (als)", "*gen/dat/acc* hij, zij, het"],
   "chapter": 22,
   "searchForm": "autos, -e, -on"
 },
 {
   "latin": "αὐτοῦ",
   "info": "",
   "definitions": ["van hem, van het"],
   "chapter": 8,
   "searchForm": "autou"
 },
 {
   "latin": "ἀφ’",
   "info": "+ gen",
   "definitions": ["van … vandaan, vanaf", "sinds"],
   "chapter": 12,
   "searchForm": "af’"
 },
 {
   "latin": "ἀφαιρέω",
   "info": "+ acc + acc",
   "definitions": ["wegnemen, afpakken"],
   "chapter": 18,
   "searchForm": "afaireo"
 },
 {
   "latin": "ἀφικνέομαι",
   "info": "",
   "definitions": ["aankomen"],
   "chapter": 33,
   "searchForm": "afikneomai"
 },
 {
   "latin": "βαθύς, -εῖα, -ύ",
   "info": "",
   "definitions": ["diep"],
   "chapter": 23,
   "searchForm": "bathus, -eia, -u"
 },
 {
   "latin": "βαίνω",
   "info": "",
   "definitions": ["gaan, stappen"],
   "chapter": 14,
   "searchForm": "baino"
 },
 {
   "latin": "βάλλω",
   "info": "",
   "definitions": ["gooien"],
   "chapter": 13,
   "searchForm": "ballo"
 },
 {
   "latin": "ὁ βάρβαρος",
   "info": "",
   "definitions": ["niet-Griek, vreemdeling"],
   "chapter": 39,
   "searchForm": "barbaros"
 },
 {
   "latin": "βάρβαρος, -α, -ον",
   "info": "",
   "definitions": ["niet-Grieks, vreemd"],
   "chapter": 39,
   "searchForm": "barbaros, -a, -on"
 },
 {
   "latin": "βαρύς, -εῖα, -ύ",
   "info": "",
   "definitions": ["zwaar, ernstig"],
   "chapter": 23,
   "searchForm": "barus, -eia, -u"
 },
 {
   "latin": "ὁ βασιλεύς, -εως",
   "info": "",
   "definitions": ["koning"],
   "chapter": 39,
   "searchForm": "basileus, -eos"
 },
 {
   "latin": "βέλτιστος, -η, -ον",
   "info": "",
   "definitions": ["best, zeer goed"],
   "chapter": 43,
   "searchForm": "beltistos, -e, -on"
 },
 {
   "latin": "βελτίων, -ον",
   "info": "",
   "definitions": ["beter"],
   "chapter": 43,
   "searchForm": "beltion, -on"
 },
 {
   "latin": "ὁ βίος",
   "info": "",
   "definitions": ["het leven"],
   "chapter": 3,
   "searchForm": "bios"
 },
 {
   "latin": "βλάπτω",
   "info": "",
   "definitions": ["schade toebrengen"],
   "chapter": 42,
   "searchForm": "blapto"
 },
 {
   "latin": "βλέπω",
   "info": "",
   "definitions": ["kijken"],
   "chapter": 6,
   "searchForm": "blepo"
 },
 {
   "latin": "ἡ βοήθεια",
   "info": "",
   "definitions": ["hulp"],
   "chapter": 7,
   "searchForm": "boetheia"
 },
 {
   "latin": "βοηθέω",
   "info": "+ dat",
   "definitions": ["helpen"],
   "chapter": 7,
   "searchForm": "boetheo"
 },
 {
   "latin": "βουλεύω",
   "info": "",
   "definitions": ["beraadslagen", "**aor** besluiten"],
   "chapter": 18,
   "searchForm": "bouleuo"
 },
 {
   "latin": "ἡ βουλή",
   "info": "",
   "definitions": ["besluit, plan", "advies, raad"],
   "chapter": 33,
   "searchForm": "boule"
 },
 {
   "latin": "βούλομαι",
   "info": "",
   "definitions": ["(graag) willen"],
   "chapter": 31,
   "searchForm": "boulomai"
 },
 {
   "latin": "βραχύς, -εῖα, -ύ",
   "info": "",
   "definitions": ["kort"],
   "chapter": 23,
   "searchForm": "brachus, -eia, -u"
 },
 {
   "latin": "γαμέω",
   "info": "(+ acc)",
   "definitions": ["trouwen (met) *(ow is een man)*"],
   "chapter": 26,
   "searchForm": "gameo"
 },
 {
   "latin": "ὁ γάμος",
   "info": "",
   "definitions": ["huwelijk"],
   "chapter": 26,
   "searchForm": "gamos"
 },
 {
   "latin": "γάρ",
   "info": "",
   "definitions": ["want, immers, namelijk"],
   "chapter": 2,
   "searchForm": "gar"
 },
 {
   "latin": "γε",
   "info": "",
   "definitions": ["*versterkt het vorige woord*"],
   "chapter": 28,
   "searchForm": "ge"
 },
 {
   "latin": "γελάω",
   "info": "",
   "definitions": ["lachen"],
   "chapter": 16,
   "searchForm": "gelao"
 },
 {
   "latin": "τὸ γένος, γένους",
   "info": "",
   "definitions": ["geslacht, afkomst", "soort, klasse"],
   "chapter": 37,
   "searchForm": "genos, genous"
 },
 {
   "latin": "ὁ γέρων, γέροντος",
   "info": "",
   "definitions": ["oude man"],
   "chapter": 9,
   "searchForm": "geron, gerontos"
 },
 {
   "latin": "ἡ γῆ",
   "info": "",
   "definitions": ["land, aarde"],
   "chapter": 2,
   "searchForm": "ge"
 },
 {
   "latin": "γίγνομαι",
   "info": "",
   "definitions": ["geboren worden, ontstaan", "worden", "gebeuren"],
   "chapter": 32,
   "searchForm": "gignomai"
 },
 {
   "latin": "γιγνώσκω",
   "info": "",
   "definitions": ["begrijpen, (leren) kennen"],
   "chapter": 11,
   "searchForm": "gignosko"
 },
 {
   "latin": "γλυκύς, -εῖα, -ύ",
   "info": "",
   "definitions": ["zoet, lief"],
   "chapter": 28,
   "searchForm": "glukus, -eia, -u"
 },
 {
   "latin": "ἡ γνώμη",
   "info": "",
   "definitions": ["inzicht, oordeel, mening"],
   "chapter": 42,
   "searchForm": "gnome"
 },
 {
   "latin": "γράφω",
   "info": "",
   "definitions": ["schrijven"],
   "chapter": 29,
   "searchForm": "grafo"
 },
 {
   "latin": "γυμνάζω",
   "info": "",
   "definitions": ["oefenen, trainen"],
   "chapter": 34,
   "searchForm": "gumnazo"
 },
 {
   "latin": "γυμνός, -ή, -όν",
   "info": "",
   "definitions": ["bloot, naakt"],
   "chapter": 33,
   "searchForm": "gumnos, -e, -on"
 },
 {
   "latin": "ἡ γυνή, γυναικός",
   "info": "",
   "definitions": ["vrouw"],
   "chapter": 6,
   "searchForm": "gune, gunaikos"
 },
 {
   "latin": "δ’ ",
   "info": "",
   "definitions": ["en, maar"],
   "chapter": 2,
   "searchForm": "d’ "
 },
 {
   "latin": "δακρύω",
   "info": "(+ acc)",
   "definitions": ["huilen (over)"],
   "chapter": 26,
   "searchForm": "dakruo"
 },
 {
   "latin": "δέ",
   "info": "",
   "definitions": ["en, maar"],
   "chapter": 2,
   "searchForm": "de"
 },
 {
   "latin": "δεῖ",
   "info": "",
   "definitions": ["**+ inf** het is nodig om", "**+ acc + inf** (iemand) moet"],
   "chapter": 31,
   "searchForm": "dei"
 },
 {
   "latin": "δείδω",
   "info": "",
   "definitions": ["vrezen"],
   "chapter": 27,
   "searchForm": "deido"
 },
 {
   "latin": "δεινός, -ή, -όν",
   "info": "",
   "definitions": ["angstaanjagend, vreselijk", "indrukwekkend"],
   "chapter": 26,
   "searchForm": "deinos, -e, -on"
 },
 {
   "latin": "τὸ δεῖπνον",
   "info": "",
   "definitions": ["maaltijd"],
   "chapter": 9,
   "searchForm": "deipnon"
 },
 {
   "latin": "δέκα",
   "info": "telwoord",
   "definitions": ["tien"],
   "chapter": 38,
   "searchForm": "deka"
 },
 {
   "latin": "τὸ δένδρον",
   "info": "",
   "definitions": ["boom"],
   "chapter": 2,
   "searchForm": "dendron"
 },
 {
   "latin": "ὁ δεσπότης, -ου",
   "info": "",
   "definitions": ["meester, heer des huizes"],
   "chapter": 44,
   "searchForm": "despotes, -ou"
 },
 {
   "latin": "δεῦρο",
   "info": "bijw",
   "definitions": ["hierheen"],
   "chapter": 17,
   "searchForm": "deuro"
 },
 {
   "latin": "δέχομαι",
   "info": "",
   "definitions": ["aannemen, ontvangen"],
   "chapter": 31,
   "searchForm": "dechomai"
 },
 {
   "latin": "δή",
   "info": "",
   "definitions": ["dus, dan, natuurlijk"],
   "chapter": 16,
   "searchForm": "de"
 },
 {
   "latin": "ὁ δῆμος",
   "info": "",
   "definitions": ["volk"],
   "chapter": 21,
   "searchForm": "demos"
 },
 {
   "latin": "δι’",
   "info": "+ acc",
   "definitions": ["wegens", "door toedoen van"],
   "chapter": 12,
   "searchForm": "di’"
 },
 {
   "latin": "δι’ ",
   "info": "+ gen",
   "definitions": ["door … heen", "gedurende"],
   "chapter": 6,
   "searchForm": "di’ "
 },
 {
   "latin": "διά",
   "info": "+ gen",
   "definitions": ["door … heen", "gedurende"],
   "chapter": 6,
   "searchForm": "dia"
 },
 {
   "latin": "διά",
   "info": "+ acc",
   "definitions": ["wegens", "door toedoen van"],
   "chapter": 12,
   "searchForm": "dia"
 },
 {
   "latin": "διαβαίνω",
   "info": "",
   "definitions": ["oversteken"],
   "chapter": 27,
   "searchForm": "diabaino"
 },
 {
   "latin": "διαλέγομαι",
   "info": "(+ dat)",
   "definitions": ["een gesprek voeren (met)"],
   "chapter": 41,
   "searchForm": "dialegomai"
 },
 {
   "latin": "διατελέω",
   "info": "",
   "definitions": ["voltooien"],
   "chapter": 43,
   "searchForm": "diateleo"
 },
 {
   "latin": "διατρίβω",
   "info": "",
   "definitions": ["(tijd) doorbrengen"],
   "chapter": 24,
   "searchForm": "diatribo"
 },
 {
   "latin": "διαφθείρω",
   "info": "",
   "definitions": ["vernietigen, bederven"],
   "chapter": 9,
   "searchForm": "diaftheiro"
 },
 {
   "latin": "δικάζω",
   "info": "",
   "definitions": ["rechtspreken, beslissen"],
   "chapter": 44,
   "searchForm": "dikazo"
 },
 {
   "latin": "ὁ δικαστής, -οῦ",
   "info": "",
   "definitions": ["rechter"],
   "chapter": 44,
   "searchForm": "dikastes, -ou"
 },
 {
   "latin": "ἡ δίκη",
   "info": "",
   "definitions": ["recht(spraak)", "rechtszaak", "vonnis, straf"],
   "chapter": 44,
   "searchForm": "dike"
 },
 {
   "latin": "διό",
   "info": "bijw",
   "definitions": ["daarom, daardoor"],
   "chapter": 29,
   "searchForm": "dio"
 },
 {
   "latin": "διότι",
   "info": "",
   "definitions": ["omdat, doordat"],
   "chapter": 17,
   "searchForm": "dioti"
 },
 {
   "latin": "διώκω",
   "info": "",
   "definitions": ["achtervolgen, wegjagen"],
   "chapter": 9,
   "searchForm": "dioko"
 },
 {
   "latin": "δοκέω",
   "info": "",
   "definitions": ["lijken, de indruk wekken", "menen"],
   "chapter": 16,
   "searchForm": "dokeo"
 },
 {
   "latin": "ὁ δόλος",
   "info": "",
   "definitions": ["list, bedrog"],
   "chapter": 4,
   "searchForm": "dolos"
 },
 {
   "latin": "τὸ δόρυ, δόρατος",
   "info": "",
   "definitions": ["lans"],
   "chapter": 6,
   "searchForm": "doru, doratos"
 },
 {
   "latin": "ὁ δοῦλος",
   "info": "",
   "definitions": ["slaaf"],
   "chapter": 22,
   "searchForm": "doulos"
 },
 {
   "latin": "δράω",
   "info": "",
   "definitions": ["doen, handelen"],
   "chapter": 19,
   "searchForm": "drao"
 },
 {
   "latin": "δυνατός",
   "info": "",
   "definitions": ["in staat", "mogelijk"],
   "chapter": 23,
   "searchForm": "dunatos"
 },
 {
   "latin": "δύο",
   "info": "telwoord",
   "definitions": ["twee"],
   "chapter": 14,
   "searchForm": "duo"
 },
 {
   "latin": "δύομαι",
   "info": "",
   "definitions": ["duiken (in), ondergaan", "aantrekken"],
   "chapter": 33,
   "searchForm": "duomai"
 },
 {
   "latin": "τὸ δῶρον",
   "info": "",
   "definitions": ["geschenk"],
   "chapter": 7,
   "searchForm": "doron"
 },
 {
   "latin": "ἐάν (εἰ ἄν)",
   "info": "+ con",
   "definitions": ["als, indien"],
   "chapter": 41,
   "searchForm": "ean (ei an)"
 },
 {
   "latin": "ἐάω",
   "info": "",
   "definitions": ["(toe)laten, toestaan"],
   "chapter": 19,
   "searchForm": "eao"
 },
 {
   "latin": "ἐγγύς",
   "info": "(+ gen)",
   "definitions": ["dichtbij"],
   "chapter": 6,
   "searchForm": "eggus"
 },
 {
   "latin": "ἐγω",
   "info": "",
   "definitions": ["ik"],
   "chapter": 8,
   "searchForm": "ego"
 },
 {
   "latin": "ἔδεισα",
   "info": "aor",
   "definitions": ["ik werd bang (voor)"],
   "chapter": 27,
   "searchForm": "edeisa"
 },
 {
   "latin": "εἷς, μία, ἑν, ἑνός",
   "info": "",
   "definitions": ["één"],
   "chapter": 34,
   "searchForm": "heis, mia, hen, henos"
 },
 {
   "latin": "εὑρίσκω",
   "info": "",
   "definitions": ["vinden"],
   "chapter": 12,
   "searchForm": "heurisko"
 },
 {
   "latin": "ἐθέλω",
   "info": "",
   "definitions": ["willen"],
   "chapter": 7,
   "searchForm": "ethelo"
 },
 {
   "latin": "τὸ ἔθνος, ἔθνους",
   "info": "",
   "definitions": ["volk"],
   "chapter": 36,
   "searchForm": "ethnos, ethnous"
 },
 {
   "latin": "τὸ ἔθος, ἔθους",
   "info": "",
   "definitions": ["gewoonte"],
   "chapter": 36,
   "searchForm": "ethos, ethous"
 },
 {
   "latin": "εἰ",
   "info": "voegwoord",
   "definitions": ["als, indien", "**indirecte vraag** of"],
   "chapter": 42,
   "searchForm": "ei"
 },
 {
   "latin": "τὸ εἶδος, εἶδους",
   "info": "",
   "definitions": ["gestalte, uiterlijk, vorm, soort"],
   "chapter": 37,
   "searchForm": "eidos, eidous"
 },
 {
   "latin": "εἴθε",
   "info": "+ opt",
   "definitions": ["moge(n) … (*leidt een wens in*)"],
   "chapter": 42,
   "searchForm": "eithe"
 },
 {
   "latin": "εἰκός (ἐστι)",
   "info": "",
   "definitions": ["het is hoogstwaarschijnlijk", "het is passend"],
   "chapter": 44,
   "searchForm": "eikos (esti)"
 },
 {
   "latin": "ἡ εἰκών, εἰκόνος",
   "info": "",
   "definitions": ["beeld, afbeelding"],
   "chapter": 23,
   "searchForm": "eikon, eikonos"
 },
 {
   "latin": "εἰμί",
   "info": "",
   "definitions": ["zijn, bestaan"],
   "chapter": 11,
   "searchForm": "eimi"
 },
 {
   "latin": "εἰς",
   "info": "+ acc",
   "definitions": ["naar (binnen)"],
   "chapter": 4,
   "searchForm": "eis"
 },
 {
   "latin": "εἰσί(ν)",
   "info": "",
   "definitions": ["(zij/er) zijn, bestaan"],
   "chapter": 2,
   "searchForm": "eisi(n)"
 },
 {
   "latin": "εἴτε … εἵτε",
   "info": "",
   "definitions": ["of … of, hetzij … hetzij"],
   "chapter": 42,
   "searchForm": "eite … heite"
 },
 {
   "latin": "ἐκ",
   "info": "+ gen",
   "definitions": ["uit"],
   "chapter": 6,
   "searchForm": "ek"
 },
 {
   "latin": "ἐκεῖνος, -η, -ο",
   "info": "",
   "definitions": ["die, dat"],
   "chapter": 22,
   "searchForm": "ekeinos, -e, -o"
 },
 {
   "latin": "ἡ ἐκκλησία",
   "info": "",
   "definitions": ["(volks)vergadering"],
   "chapter": 41,
   "searchForm": "ekklesia"
 },
 {
   "latin": "ἐλαύνω",
   "info": "",
   "definitions": ["(voort)drijven"],
   "chapter": 39,
   "searchForm": "elauno"
 },
 {
   "latin": "ἐλπίζω",
   "info": "",
   "definitions": ["hopen (op), verwachten"],
   "chapter": 13,
   "searchForm": "elpizo"
 },
 {
   "latin": "ἐμέ",
   "info": "",
   "definitions": ["me"],
   "chapter": 8,
   "searchForm": "eme"
 },
 {
   "latin": "ἐμοί",
   "info": "",
   "definitions": ["aan/voor mij"],
   "chapter": 8,
   "searchForm": "emoi"
 },
 {
   "latin": "ἐμός, -ή, -όν",
   "info": "",
   "definitions": ["mijn, van mij"],
   "chapter": 41,
   "searchForm": "emos, -e, -on"
 },
 {
   "latin": "ἐμοῦ",
   "info": "",
   "definitions": ["van mij"],
   "chapter": 8,
   "searchForm": "emou"
 },
 {
   "latin": "ἐν",
   "info": "+ dat",
   "definitions": ["in, op, bij"],
   "chapter": 7,
   "searchForm": "en"
 },
 {
   "latin": "ἐν νῷ ἔχω",
   "info": "",
   "definitions": ["van plan zijn"],
   "chapter": 37,
   "searchForm": "en noi echo"
 },
 {
   "latin": "ἐνθάδε",
   "info": "",
   "definitions": ["hier"],
   "chapter": 39,
   "searchForm": "enthade"
 },
 {
   "latin": "ὁ ἐνιαυτός",
   "info": "",
   "definitions": ["jaar"],
   "chapter": 26,
   "searchForm": "eniautos"
 },
 {
   "latin": "ἐνίοτε",
   "info": "",
   "definitions": ["soms"],
   "chapter": 24,
   "searchForm": "eniote"
 },
 {
   "latin": "ἐνταῦθα",
   "info": "bijw",
   "definitions": ["daar"],
   "chapter": 2,
   "searchForm": "entautha"
 },
 {
   "latin": "ἐντυγχάνω",
   "info": "+ dat",
   "definitions": ["tegenkomen, ontmoeten"],
   "chapter": 27,
   "searchForm": "entugchano"
 },
 {
   "latin": "ἐξ",
   "info": "+ gen",
   "definitions": ["uit"],
   "chapter": 6,
   "searchForm": "ex"
 },
 {
   "latin": "ἐξαίφνης",
   "info": "bijw",
   "definitions": ["plotseling"],
   "chapter": 14,
   "searchForm": "exaifnes"
 },
 {
   "latin": "ἔξεστι(ν)",
   "info": "+ inf",
   "definitions": ["het is mogelijk om"],
   "chapter": 17,
   "searchForm": "exesti(n)"
 },
 {
   "latin": "ἔξω",
   "info": "+ gen",
   "definitions": ["buiten"],
   "chapter": 38,
   "searchForm": "exo"
 },
 {
   "latin": "ἐπ’",
   "info": "+ dat",
   "definitions": ["aan, bij"],
   "chapter": 8,
   "searchForm": "ep’"
 },
 {
   "latin": "ἐπ’",
   "info": "+ gen",
   "definitions": ["op", "tijdens"],
   "chapter": 12,
   "searchForm": "ep’"
 },
 {
   "latin": "ἐπ’",
   "info": "+ acc",
   "definitions": ["op … af, naar", "gedurende"],
   "chapter": 31,
   "searchForm": "ep’"
 },
 {
   "latin": "ἐπεί",
   "info": "voegwoord",
   "definitions": ["toen, nadat", "omdat, aangezien"],
   "chapter": 12,
   "searchForm": "epei"
 },
 {
   "latin": "ἐπειδάν",
   "info": "+ con",
   "definitions": ["nadat"],
   "chapter": 41,
   "searchForm": "epeidan"
 },
 {
   "latin": "ἐπειδή",
   "info": "voegwoord",
   "definitions": ["toen, nadat", "omdat, aangezien"],
   "chapter": 12,
   "searchForm": "epeide"
 },
 {
   "latin": "ἔπειτα",
   "info": "bijw",
   "definitions": ["daarna"],
   "chapter": 2,
   "searchForm": "epeita"
 },
 {
   "latin": "ἐπί",
   "info": "+ dat",
   "definitions": ["aan, bij"],
   "chapter": 8,
   "searchForm": "epi"
 },
 {
   "latin": "ἐπί",
   "info": "+ gen",
   "definitions": ["op", "tijdens"],
   "chapter": 12,
   "searchForm": "epi"
 },
 {
   "latin": "ἐπί",
   "info": "+ acc",
   "definitions": ["op … af, naar", "gedurende"],
   "chapter": 31,
   "searchForm": "epi"
 },
 {
   "latin": "ἐπιθυμέω",
   "info": "",
   "definitions": ["**+ gen** verlangen naar", "**+ inf** ernaar verlangen om"],
   "chapter": 17,
   "searchForm": "epithumeo"
 },
 {
   "latin": "ἡ ἐπιμέλεια",
   "info": "",
   "definitions": ["zorg, aandacht"],
   "chapter": 38,
   "searchForm": "epimeleia"
 },
 {
   "latin": "ἡ ἐπιστολή",
   "info": "",
   "definitions": ["brief"],
   "chapter": 29,
   "searchForm": "epistole"
 },
 {
   "latin": "ἐπιχειρέω",
   "info": "+ dat",
   "definitions": ["aanvallen"],
   "chapter": 39,
   "searchForm": "epicheireo"
 },
 {
   "latin": "τὸ ἔπος, ἔπους",
   "info": "",
   "definitions": ["woord, uitspraak, verhaal"],
   "chapter": 38,
   "searchForm": "epos, epous"
 },
 {
   "latin": "τὸ ἔργον",
   "info": "",
   "definitions": ["werk, taak", "daad"],
   "chapter": 2,
   "searchForm": "ergon"
 },
 {
   "latin": "ἔρημος, -ον",
   "info": "",
   "definitions": ["eenzaam, verlaten", "**+ gen** beroofd van, zonder"],
   "chapter": 29,
   "searchForm": "eremos, -on"
 },
 {
   "latin": "ἔρχομαι",
   "info": "",
   "definitions": ["gaan, komen"],
   "chapter": 31,
   "searchForm": "erchomai"
 },
 {
   "latin": "ὁ ἔρως, ἔρωτος",
   "info": "",
   "definitions": ["liefde, begeerte"],
   "chapter": 27,
   "searchForm": "eros, erotos"
 },
 {
   "latin": "ἐρωτάω",
   "info": "",
   "definitions": ["vragen"],
   "chapter": 16,
   "searchForm": "erotao"
 },
 {
   "latin": "ἡ ἐσθής, ἐσθῆτος",
   "info": "",
   "definitions": ["kleding(stuk)"],
   "chapter": 6,
   "searchForm": "esthes, esthetos"
 },
 {
   "latin": "ἐσθίω",
   "info": "",
   "definitions": ["eten"],
   "chapter": 18,
   "searchForm": "esthio"
 },
 {
   "latin": "ἐστί(ν)",
   "info": "",
   "definitions": ["(hij/zij/het/er) is, bestaat"],
   "chapter": 2,
   "searchForm": "esti(n)"
 },
 {
   "latin": "ἔτι",
   "info": "",
   "definitions": ["nog"],
   "chapter": 11,
   "searchForm": "eti"
 },
 {
   "latin": "τὸ ἔτος, ἔτους",
   "info": "",
   "definitions": ["jaar"],
   "chapter": 38,
   "searchForm": "etos, etous"
 },
 {
   "latin": "εὖ",
   "info": "bijw",
   "definitions": ["goed"],
   "chapter": 32,
   "searchForm": "eu"
 },
 {
   "latin": "εὐδαίμων, -ον",
   "info": "",
   "definitions": ["gelukkig"],
   "chapter": 44,
   "searchForm": "eudaimon, -on"
 },
 {
   "latin": "εὐθύς",
   "info": "bijw",
   "definitions": ["onmiddellijk"],
   "chapter": 18,
   "searchForm": "euthus"
 },
 {
   "latin": "ἡ εὔνοια",
   "info": "",
   "definitions": ["welwillendheid, goede wil"],
   "chapter": 42,
   "searchForm": "eunoia"
 },
 {
   "latin": "εὐρύς, -εῖα, -ύ",
   "info": "",
   "definitions": ["breed"],
   "chapter": 23,
   "searchForm": "eurus, -eia, -u"
 },
 {
   "latin": "εὔχομαι",
   "info": "",
   "definitions": ["bidden, wensen"],
   "chapter": 36,
   "searchForm": "euchomai"
 },
 {
   "latin": "ἐφ’",
   "info": "+ dat",
   "definitions": ["aan, bij"],
   "chapter": 8,
   "searchForm": "ef’"
 },
 {
   "latin": "ἐφ’",
   "info": "+ gen",
   "definitions": ["op", "tijdens"],
   "chapter": 12,
   "searchForm": "ef’"
 },
 {
   "latin": "ἐφ’",
   "info": "+ acc",
   "definitions": ["op … af, naar", "gedurende"],
   "chapter": 31,
   "searchForm": "ef’"
 },
 {
   "latin": "ἔχω",
   "info": "",
   "definitions": ["hebben, houden"],
   "chapter": 4,
   "searchForm": "echo"
 },
 {
   "latin": "ζητέω",
   "info": "",
   "definitions": ["zoeken"],
   "chapter": 16,
   "searchForm": "zeteo"
 },
 {
   "latin": "ἤ",
   "info": "",
   "definitions": ["of", "**vergelijking** dan"],
   "chapter": 22,
   "searchForm": "e"
 },
 {
   "latin": "ἤδη",
   "info": "bijw",
   "definitions": ["al, reeds", "(vanaf) nu"],
   "chapter": 6,
   "searchForm": "ede"
 },
 {
   "latin": "ἦλθον",
   "info": "aor",
   "definitions": ["ik kwam, ik ging"],
   "chapter": 27,
   "searchForm": "elthon"
 },
 {
   "latin": "αἱρέομαι",
   "info": "",
   "definitions": ["kiezen"],
   "chapter": 32,
   "searchForm": "haireomai"
 },
 {
   "latin": "αἱρέω",
   "info": "",
   "definitions": ["grijpen, pakken"],
   "chapter": 14,
   "searchForm": "aἱreo"
 },
 {
   "latin": "ἁλίσκομαι",
   "info": "",
   "definitions": ["gevangen genomen worden", "betrapt worden"],
   "chapter": 33,
   "searchForm": "haliskomai"
 },
 {
   "latin": "ἅμ’",
   "info": "(+ dat)",
   "definitions": ["tegelijk (met)"],
   "chapter": 32,
   "searchForm": "ham’"
 },
 {
   "latin": "ἅμα",
   "info": "(+ dat)",
   "definitions": ["tegelijk (met)"],
   "chapter": 32,
   "searchForm": "hama"
 },
 {
   "latin": "ἁμαρτάνω",
   "info": "",
   "definitions": ["**+ gen** (het doel) missen", "zich vergissen"],
   "chapter": 22,
   "searchForm": "hamartano"
 },
 {
   "latin": "ἅπτομαι",
   "info": "+ gen",
   "definitions": ["vastpakken, aanraken"],
   "chapter": 32,
   "searchForm": "haptomai"
 },
 {
   "latin": "τὸ ἅρμα, ἅρματος",
   "info": "",
   "definitions": ["(strijd)wagen"],
   "chapter": 31,
   "searchForm": "harma, harmatos"
 },
 {
   "latin": "ἁρπάζω",
   "info": "",
   "definitions": ["roven"],
   "chapter": 9,
   "searchForm": "harpazo"
 },
 {
   "latin": "ἅτε",
   "info": "+ ptc",
   "definitions": ["omdat, aangezien"],
   "chapter": 26,
   "searchForm": "hate"
 },
 {
   "latin": "ἑαυτοῦ, ἑαυτῆς, ἑαυτοῦ",
   "info": "",
   "definitions": ["*gen/dat/acc* zichzelf"],
   "chapter": 28,
   "searchForm": "heautou, heautes, heautou"
 },
 {
   "latin": "ἕκαστος, -η, -ον",
   "info": "",
   "definitions": ["ieder, elk"],
   "chapter": 22,
   "searchForm": "hekastos, -e, -on"
 },
 {
   "latin": "ἑκών, ἑκοῦσα, ἑκόν, ἑκόντος",
   "info": "",
   "definitions": ["vrijwillig, expres"],
   "chapter": 23,
   "searchForm": "hekon, hekousa, hekon, hekontos"
 },
 {
   "latin": "ἡ Ἑλλάς, Ἑλλάδος ",
   "info": "",
   "definitions": ["Griekenland"],
   "chapter": 8,
   "searchForm": "Hellas, Hellados "
 },
 {
   "latin": "ὁ Ἕλλην, Ἕλληνος",
   "info": "",
   "definitions": ["Griek"],
   "chapter": 6,
   "searchForm": "Hellen, Hellenos"
 },
 {
   "latin": "Ἑλληνικός, -ή, -όν",
   "info": "",
   "definitions": ["Grieks"],
   "chapter": 39,
   "searchForm": "Hellenikos, -e, -on"
 },
 {
   "latin": "ἕνεκα",
   "info": "+ gen",
   "definitions": ["wegens, omwille van"],
   "chapter": 43,
   "searchForm": "heneka"
 },
 {
   "latin": "ἕξ",
   "info": "telwoord",
   "definitions": ["zes"],
   "chapter": 26,
   "searchForm": "hex"
 },
 {
   "latin": "ἕπομαι",
   "info": "+ dat",
   "definitions": ["volgen, meegaan met"],
   "chapter": 31,
   "searchForm": "hepomai"
 },
 {
   "latin": "ἡ ἑσπέρα",
   "info": "",
   "definitions": ["avond"],
   "chapter": 36,
   "searchForm": "hespera"
 },
 {
   "latin": "ὁ ἑταῖρος ",
   "info": "",
   "definitions": ["makker, vriend"],
   "chapter": 24,
   "searchForm": "hetairos "
 },
 {
   "latin": "ἕτοιμος, -η, -ον",
   "info": "",
   "definitions": ["gereed, bereid"],
   "chapter": 28,
   "searchForm": "hetoimos, -e, -on"
 },
 {
   "latin": "ἡ",
   "info": "",
   "definitions": ["de, het"],
   "chapter": 2,
   "searchForm": "he"
 },
 {
   "latin": "ὁ ἡγεμών, ἡγεμόνος",
   "info": "",
   "definitions": ["leider, aanvoerder"],
   "chapter": 6,
   "searchForm": "hegemon, hegemonos"
 },
 {
   "latin": "ἡγέομαι",
   "info": "",
   "definitions": ["menen, beschouwen als"],
   "chapter": 36,
   "searchForm": "hegeomai"
 },
 {
   "latin": "ἡδέως",
   "info": "bijw",
   "definitions": ["graag"],
   "chapter": 37,
   "searchForm": "hedeos"
 },
 {
   "latin": "ἥδομαι",
   "info": "(+ dat)",
   "definitions": ["zich verheugen (over)"],
   "chapter": 33,
   "searchForm": "hedomai"
 },
 {
   "latin": "ἡ ἡδονή",
   "info": "",
   "definitions": ["genot, vreugde"],
   "chapter": 24,
   "searchForm": "hedone"
 },
 {
   "latin": "ἡδύς, -εῖα, -ύ",
   "info": "",
   "definitions": ["aangenaam, fijn"],
   "chapter": 23,
   "searchForm": "hedus, -eia, -u"
 },
 {
   "latin": "ἥκω",
   "info": "",
   "definitions": ["komen, gekomen zijn"],
   "chapter": 9,
   "searchForm": "heko"
 },
 {
   "latin": "ὁ ἥλιος",
   "info": "",
   "definitions": ["zon"],
   "chapter": 3,
   "searchForm": "helios"
 },
 {
   "latin": "ἧμαι",
   "info": "",
   "definitions": ["zitten"],
   "chapter": 38,
   "searchForm": "hemai"
 },
 {
   "latin": "ἡμᾶς",
   "info": "",
   "definitions": ["ons"],
   "chapter": 8,
   "searchForm": "hemas"
 },
 {
   "latin": "ἡμεῖς",
   "info": "",
   "definitions": ["wij"],
   "chapter": 8,
   "searchForm": "hemeis"
 },
 {
   "latin": "ἡ ἡμέρα",
   "info": "",
   "definitions": ["dag"],
   "chapter": 24,
   "searchForm": "hemera"
 },
 {
   "latin": "ἡμέτερος, -α, -ον",
   "info": "",
   "definitions": ["onze, van ons"],
   "chapter": 21,
   "searchForm": "hemeteros, -a, -on"
 },
 {
   "latin": "ἡμῖν",
   "info": "",
   "definitions": ["aan/voor ons"],
   "chapter": 8,
   "searchForm": "hemin"
 },
 {
   "latin": "τὸ ἥμισυ",
   "info": "",
   "definitions": ["de helft"],
   "chapter": 26,
   "searchForm": "hemisu"
 },
 {
   "latin": "ἡμῶν",
   "info": "",
   "definitions": ["van ons"],
   "chapter": 8,
   "searchForm": "hemon"
 },
 {
   "latin": "ὁ ἥρως, ἥρωος",
   "info": "",
   "definitions": ["held"],
   "chapter": 7,
   "searchForm": "heros, heroos"
 },
 {
   "latin": "ἥττων, ἥττονος",
   "info": "",
   "definitions": ["zwakker, minder"],
   "chapter": 32,
   "searchForm": "hetton, hettonos"
 },
 {
   "latin": "τὸ ἱερόν",
   "info": "",
   "definitions": ["heiligdom"],
   "chapter": 43,
   "searchForm": "hieron"
 },
 {
   "latin": "ἱκανός, -ή, -όν",
   "info": "",
   "definitions": ["voldoende, geschikt"],
   "chapter": 38,
   "searchForm": "hikanos, -e, -on"
 },
 {
   "latin": "ἱκετεύω",
   "info": "",
   "definitions": ["smeken"],
   "chapter": 23,
   "searchForm": "hiketeuo"
 },
 {
   "latin": "ἵνα",
   "info": "+ con",
   "definitions": ["(met de bedoeling) dat, om te"],
   "chapter": 41,
   "searchForm": "hina"
 },
 {
   "latin": "ὁ ἵππος ",
   "info": "",
   "definitions": ["paard"],
   "chapter": 3,
   "searchForm": "hippos"
 },
 {
   "latin": "ὁ",
   "info": "",
   "definitions": ["de, het"],
   "chapter": 2,
   "searchForm": "ho"
 },
 {
   "latin": "ὅδε, ἥδε, τόδε",
   "info": "",
   "definitions": ["deze, dit"],
   "chapter": 22,
   "searchForm": "hode, hede, tode"
 },
 {
   "latin": "ἡ ὁδός",
   "info": "",
   "definitions": ["weg", "tocht"],
   "chapter": 9,
   "searchForm": "hodos"
 },
 {
   "latin": "οἱ μέν … οἱ δέ …",
   "info": "mv",
   "definitions": ["sommigen … anderen …"],
   "chapter": 14,
   "searchForm": "hoi men … hoi de …"
 },
 {
   "latin": "ὅλος, -η, -ον",
   "info": "",
   "definitions": ["(ge)heel, volledig"],
   "chapter": 34,
   "searchForm": "holos, -e, -on"
 },
 {
   "latin": "ὅμοιος",
   "info": "",
   "definitions": ["lijkend op, gelijk aan"],
   "chapter": 24,
   "searchForm": "homoios"
 },
 {
   "latin": "ὁμολογέω",
   "info": "(+ dat)",
   "definitions": ["het eens zijn (met)"],
   "chapter": 23,
   "searchForm": "homologeo"
 },
 {
   "latin": "ὅμως",
   "info": "bijw",
   "definitions": ["toch"],
   "chapter": 29,
   "searchForm": "homos"
 },
 {
   "latin": "ὁπόταν (ὁπότε ἄν)",
   "info": "+ con",
   "definitions": ["(telkens) wanneer"],
   "chapter": 44,
   "searchForm": "hopotan"
 },
 {
   "latin": "ὁπότε",
   "info": "",
   "definitions": ["wanneer, toen"],
   "chapter": 44,
   "searchForm": "hopote"
 },
 {
   "latin": "ὅπως",
   "info": "+ con",
   "definitions": ["(met de bedoeling) dat, om te"],
   "chapter": 41,
   "searchForm": "hopos"
 },
 {
   "latin": "ὁράω",
   "info": "",
   "definitions": ["zien"],
   "chapter": 12,
   "searchForm": "horao"
 },
 {
   "latin": "ὅς, ἥ, ὅ",
   "info": "",
   "definitions": ["die, dat"],
   "chapter": 38,
   "searchForm": "hos, he, ho"
 },
 {
   "latin": "ὅταν (ὅτε ἄν)",
   "info": "+ con",
   "definitions": ["(telkens) wanneer"],
   "chapter": 41,
   "searchForm": "hotan (hote an)"
 },
 {
   "latin": "ὅτε",
   "info": "voegwoord",
   "definitions": ["wanneer, toen, nu"],
   "chapter": 24,
   "searchForm": "hote"
 },
 {
   "latin": "ὅτι",
   "info": "",
   "definitions": ["dat", "omdat"],
   "chapter": 11,
   "searchForm": "hoti"
 },
 {
   "latin": "ὑγιής, -ές",
   "info": "",
   "definitions": ["gezond"],
   "chapter": 42,
   "searchForm": "hugies, -es"
 },
 {
   "latin": "τὸ ὕδωρ, ὕδατος",
   "info": "",
   "definitions": ["water"],
   "chapter": 14,
   "searchForm": "hudor, hudatos"
 },
 {
   "latin": "ὑμᾶς",
   "info": "",
   "definitions": ["jullie"],
   "chapter": 8,
   "searchForm": "humas"
 },
 {
   "latin": "ὑμεῖς",
   "info": "",
   "definitions": ["jullie"],
   "chapter": 8,
   "searchForm": "humeis"
 },
 {
   "latin": "ὑμέτερος, -α, -ον",
   "info": "",
   "definitions": ["jullie, van jullie"],
   "chapter": 38,
   "searchForm": "humeteros, -a, -on"
 },
 {
   "latin": "ὑμῖν",
   "info": "",
   "definitions": ["aan/voor jullie"],
   "chapter": 8,
   "searchForm": "humin"
 },
 {
   "latin": "ὑμῶν",
   "info": "",
   "definitions": ["van jullie"],
   "chapter": 8,
   "searchForm": "humon"
 },
 {
   "latin": "ὑπ’",
   "info": "+ gen",
   "definitions": ["onder", "**+ pass** door"],
   "chapter": 32,
   "searchForm": "hup’"
 },
 {
   "latin": "ὑπέρ",
   "info": "+ gen",
   "definitions": ["boven"],
   "chapter": 16,
   "searchForm": "huper"
 },
 {
   "latin": "ὑπέρ",
   "info": "+ acc",
   "definitions": ["over, aan de overzijde van", "boven, te boven gaand"],
   "chapter": 27,
   "searchForm": "huper"
 },
 {
   "latin": "ὑπερβάλλω",
   "info": "",
   "definitions": ["overtreffen"],
   "chapter": 38,
   "searchForm": "huperballo"
 },
 {
   "latin": "ὑπισχνέομαι",
   "info": "",
   "definitions": ["beloven"],
   "chapter": 31,
   "searchForm": "hupischneomai"
 },
 {
   "latin": "ὁ ὕπνος",
   "info": "",
   "definitions": ["slaap"],
   "chapter": 44,
   "searchForm": "hupnos"
 },
 {
   "latin": "ὑπό",
   "info": "+ gen",
   "definitions": ["onder", "**+ pass** door"],
   "chapter": 32,
   "searchForm": "hupo"
 },
 {
   "latin": "ὑστερον",
   "info": "bijw",
   "definitions": ["later"],
   "chapter": 36,
   "searchForm": "husteron"
 },
 {
   "latin": "ὑφ’",
   "info": "+ gen",
   "definitions": ["onder", "**+ pass** door"],
   "chapter": 32,
   "searchForm": "huf’"
 },
 {
   "latin": "ὑψηλός, -ή, -όν",
   "info": "",
   "definitions": ["hoog"],
   "chapter": 21,
   "searchForm": "hupselos, -e, -on"
 },
 {
   "latin": "ἡ ὥρα",
   "info": "",
   "definitions": ["seizoen", "uur, tijd van de dag"],
   "chapter": 41,
   "searchForm": "hora"
 },
 {
   "latin": "ὡς",
   "info": "",
   "definitions": ["zo(als)", "hoe, wat (*in een uitroep*)"],
   "chapter": 22,
   "searchForm": "hos"
 },
 {
   "latin": "ὡς",
   "info": "voegwoord",
   "definitions": ["dat"],
   "chapter": 34,
   "searchForm": "hos"
 },
 {
   "latin": "ὡς τάχιστα",
   "info": "",
   "definitions": ["**bijw** zo snel mogelijk", "**voegw** zodra"],
   "chapter": 7,
   "searchForm": "hos tachista"
 },
 {
   "latin": "ὥσπερ",
   "info": "",
   "definitions": ["(net) zoals", "net alsof"],
   "chapter": 32,
   "searchForm": "hosper"
 },
 {
   "latin": "ἡ θάλαττα",
   "info": "",
   "definitions": ["zee"],
   "chapter": 8,
   "searchForm": "thalatta"
 },
 {
   "latin": "ὁ θάνατος",
   "info": "",
   "definitions": ["de dood"],
   "chapter": 14,
   "searchForm": "thanatos"
 },
 {
   "latin": "θάπτω",
   "info": "",
   "definitions": ["begraven"],
   "chapter": 29,
   "searchForm": "thapto"
 },
 {
   "latin": "θαυμάζω",
   "info": "",
   "definitions": ["bewonderen", "zich verwonderen over"],
   "chapter": 14,
   "searchForm": "thaumazo"
 },
 {
   "latin": "θαυμαστός, -ή, -όν",
   "info": "",
   "definitions": ["wonderlijk, bijzonder"],
   "chapter": 21,
   "searchForm": "thaumastos, -e, -on"
 },
 {
   "latin": "ἡ θεά",
   "info": "",
   "definitions": ["godin"],
   "chapter": 2,
   "searchForm": "thea"
 },
 {
   "latin": "θεάομαι",
   "info": "",
   "definitions": ["bekijken, beschouwen"],
   "chapter": 32,
   "searchForm": "theaomai"
 },
 {
   "latin": "ὁ θεός",
   "info": "",
   "definitions": ["god"],
   "chapter": 2,
   "searchForm": "theos"
 },
 {
   "latin": "θερμός, -ή, -όν",
   "info": "",
   "definitions": ["warm"],
   "chapter": 24,
   "searchForm": "thermos, -e, -on"
 },
 {
   "latin": "τὸ θηρίον",
   "info": "",
   "definitions": ["(wild) dier"],
   "chapter": 3,
   "searchForm": "therion"
 },
 {
   "latin": "θνῄσκω",
   "info": "",
   "definitions": ["sterven, omkomen"],
   "chapter": 12,
   "searchForm": "thneisko"
 },
 {
   "latin": "ὁ θρόνος ",
   "info": "",
   "definitions": ["troon"],
   "chapter": 4,
   "searchForm": "thronos "
 },
 {
   "latin": "ἡ θυγάτηρ, θυγατρός",
   "info": "",
   "definitions": ["dochter"],
   "chapter": 6,
   "searchForm": "thugater, thugatros"
 },
 {
   "latin": "θύω",
   "info": "",
   "definitions": ["offeren"],
   "chapter": 17,
   "searchForm": "thuo"
 },
 {
   "latin": "ἴδιος, -α, -ον",
   "info": "",
   "definitions": ["eigen"],
   "chapter": 39,
   "searchForm": "idios, -a, -on"
 },
 {
   "latin": "ἰδού",
   "info": "",
   "definitions": ["zie daar"],
   "chapter": 32,
   "searchForm": "idou"
 },
 {
   "latin": "ἰσχυρός, -ά, -όν",
   "info": "",
   "definitions": ["krachtig, sterk"],
   "chapter": 22,
   "searchForm": "ischuros, -a, -on"
 },
 {
   "latin": "ἡ ἰσχύς, ἰσχύος",
   "info": "",
   "definitions": ["kracht"],
   "chapter": 34,
   "searchForm": "ischus, ischuos"
 },
 {
   "latin": "ἴσως",
   "info": "bijw",
   "definitions": ["misschien"],
   "chapter": 34,
   "searchForm": "isos"
 },
 {
   "latin": "καθ’",
   "info": "+ acc",
   "definitions": ["(verspreid) over", "overeenkomstig"],
   "chapter": 9,
   "searchForm": "kath’"
 },
 {
   "latin": "καθαρός, -ά, -όν",
   "info": "",
   "definitions": ["schoon, zuiver"],
   "chapter": 22,
   "searchForm": "katharos, -a, -on"
 },
 {
   "latin": "καί",
   "info": "",
   "definitions": ["en", "ook, zelfs"],
   "chapter": 2,
   "searchForm": "kai"
 },
 {
   "latin": "καί … καί",
   "info": "",
   "definitions": ["zowel … als"],
   "chapter": 31,
   "searchForm": "kai … kai"
 },
 {
   "latin": "καὶ δὴ καί",
   "info": "",
   "definitions": ["en ook, en vooral"],
   "chapter": 16,
   "searchForm": "kai de kai"
 },
 {
   "latin": "καινός, -ή, -όν",
   "info": "",
   "definitions": ["nieuw"],
   "chapter": 33,
   "searchForm": "kainos, -e, -on"
 },
 {
   "latin": "καίπερ",
   "info": "+ ptc",
   "definitions": ["hoewel, ook al"],
   "chapter": 28,
   "searchForm": "kaiper"
 },
 {
   "latin": "τὸ κακόν",
   "info": "",
   "definitions": ["(het) kwaad, ramp"],
   "chapter": 38,
   "searchForm": "kakon"
 },
 {
   "latin": "κακός, -ή, -όν",
   "info": "",
   "definitions": ["slecht, laf"],
   "chapter": 21,
   "searchForm": "kakos, -e, -on"
 },
 {
   "latin": "καλέω",
   "info": "",
   "definitions": ["roepen, noemen"],
   "chapter": 16,
   "searchForm": "kaleo"
 },
 {
   "latin": "καλός, -ή, -όν",
   "info": "",
   "definitions": ["mooi, goed"],
   "chapter": 21,
   "searchForm": "kalos, -e, -on"
 },
 {
   "latin": "ὁ καρπός ",
   "info": "",
   "definitions": ["vrucht", "gewas", "opbrengst"],
   "chapter": 26,
   "searchForm": "karpos "
 },
 {
   "latin": "καρτερός, -ά, -όν",
   "info": "",
   "definitions": ["sterk, krachtig"],
   "chapter": 34,
   "searchForm": "karteros, -a, -on"
 },
 {
   "latin": "κατ’",
   "info": "+ acc",
   "definitions": ["(verspreid) over", "overeenkomstig"],
   "chapter": 9,
   "searchForm": "kat’"
 },
 {
   "latin": "κατ’",
   "info": "+ gen",
   "definitions": ["van … af (naar beneden)"],
   "chapter": 16,
   "searchForm": "kat’"
 },
 {
   "latin": "κατά",
   "info": "+ acc",
   "definitions": ["(verspreid) over", "overeenkomstig"],
   "chapter": 9,
   "searchForm": "kata"
 },
 {
   "latin": "κατά",
   "info": "+ gen",
   "definitions": ["van … af (naar beneden)"],
   "chapter": 16,
   "searchForm": "kata"
 },
 {
   "latin": "κατα-",
   "info": "voorvoegsel",
   "definitions": ["naar beneden, neer-"],
   "chapter": 16,
   "searchForm": "kata-"
 },
 {
   "latin": "κατέχω",
   "info": "",
   "definitions": ["vasthouden, tegenhouden", "in zijn macht houden, beheersen"],
   "chapter": 27,
   "searchForm": "katecho"
 },
 {
   "latin": "κατθ’",
   "info": "+ gen",
   "definitions": ["van … af (naar beneden)"],
   "chapter": 16,
   "searchForm": "katth’"
 },
 {
   "latin": "κατοικέω",
   "info": "",
   "definitions": ["gaan (be)wonen"],
   "chapter": 43,
   "searchForm": "katoikeo"
 },
 {
   "latin": "κεῖμαι",
   "info": "",
   "definitions": ["liggen"],
   "chapter": 39,
   "searchForm": "keimai"
 },
 {
   "latin": "κελεύω",
   "info": "",
   "definitions": ["bevelen, verzoeken"],
   "chapter": 18,
   "searchForm": "keleuo"
 },
 {
   "latin": "κενός, -ή, -όν",
   "info": "",
   "definitions": ["leeg"],
   "chapter": 22,
   "searchForm": "kenos, -e, -on"
 },
 {
   "latin": "ἡ κεφαλή",
   "info": "",
   "definitions": ["hoofd"],
   "chapter": 6,
   "searchForm": "kefale"
 },
 {
   "latin": "ὁ κίνδυνος",
   "info": "",
   "definitions": ["gevaar"],
   "chapter": 8,
   "searchForm": "kindunos"
 },
 {
   "latin": "κινέω",
   "info": "",
   "definitions": ["bewegen"],
   "chapter": 24,
   "searchForm": "kineo"
 },
 {
   "latin": "κλέπτω",
   "info": "",
   "definitions": ["stelen"],
   "chapter": 18,
   "searchForm": "klepto"
 },
 {
   "latin": "ἡ κόρη",
   "info": "",
   "definitions": ["meisje"],
   "chapter": 4,
   "searchForm": "kore"
 },
 {
   "latin": "ὁ κόσμος",
   "info": "",
   "definitions": ["wereld(orde)", "sier, opsmuk"],
   "chapter": 37,
   "searchForm": "kosmos"
 },
 {
   "latin": "κρατέω",
   "info": "",
   "definitions": ["de sterkste zijn", "**+ gen** heersen over"],
   "chapter": 19,
   "searchForm": "krateo"
 },
 {
   "latin": "κράτιστος, -η, -ον",
   "info": "",
   "definitions": ["sterkst, best"],
   "chapter": 34,
   "searchForm": "kratistos, -e, -on"
 },
 {
   "latin": "κρείττων, κρείττονος",
   "info": "",
   "definitions": ["sterker, beter"],
   "chapter": 29,
   "searchForm": "kreitton, kreittonos"
 },
 {
   "latin": "ἡ κρίσις, κρίσεως",
   "info": "",
   "definitions": ["beslissing, oordeel, uitspraak"],
   "chapter": 41,
   "searchForm": "krisis, kriseos"
 },
 {
   "latin": "κρύπτω",
   "info": "",
   "definitions": ["verbergen"],
   "chapter": 17,
   "searchForm": "krupto"
 },
 {
   "latin": "κτάομαι",
   "info": "",
   "definitions": ["verwerven"],
   "chapter": 31,
   "searchForm": "ktaomai"
 },
 {
   "latin": "κτείνω",
   "info": "",
   "definitions": ["doden"],
   "chapter": 7,
   "searchForm": "kteino"
 },
 {
   "latin": "ὁ κύων, κυνός",
   "info": "",
   "definitions": ["hond"],
   "chapter": 27,
   "searchForm": "kuon, kunos"
 },
 {
   "latin": "κωλύω",
   "info": "",
   "definitions": ["tegenhouden, verhinderen"],
   "chapter": 11,
   "searchForm": "koluo"
 },
 {
   "latin": "λαμβάνω",
   "info": "",
   "definitions": ["nemen, krijgen"],
   "chapter": 11,
   "searchForm": "lambano"
 },
 {
   "latin": "λαμπρός, -ά, -όν",
   "info": "",
   "definitions": ["schitterend"],
   "chapter": 29,
   "searchForm": "lampros, -a, -on"
 },
 {
   "latin": "λανθάνω",
   "info": "",
   "definitions": ["**+ acc** verborgen zijn voor", "**+ ptc** verborgen blijven bij het …"],
   "chapter": 38,
   "searchForm": "lanthano"
 },
 {
   "latin": "λέγω",
   "info": "",
   "definitions": ["zeggen, spreken"],
   "chapter": 3,
   "searchForm": "lego"
 },
 {
   "latin": "λείπω",
   "info": "",
   "definitions": ["verlaten, achterlaten"],
   "chapter": 12,
   "searchForm": "leipo"
 },
 {
   "latin": "ὁ λιμήν, λιμένος",
   "info": "",
   "definitions": ["haven"],
   "chapter": 8,
   "searchForm": "limen, limenos"
 },
 {
   "latin": "λογίζομαι",
   "info": "",
   "definitions": ["(be)rekenen", "overwegen, overdenken"],
   "chapter": 38,
   "searchForm": "logizomai"
 },
 {
   "latin": "ὁ λόγος",
   "info": "",
   "definitions": ["woord, verhaal"],
   "chapter": 9,
   "searchForm": "logos"
 },
 {
   "latin": "λυπέω",
   "info": "",
   "definitions": ["pijn doen, verdriet doen"],
   "chapter": 19,
   "searchForm": "lupeo"
 },
 {
   "latin": "λύω",
   "info": "",
   "definitions": ["losmaken, bevrijden"],
   "chapter": 11,
   "searchForm": "luo"
 },
 {
   "latin": "μακρός, -ά, -όν",
   "info": "",
   "definitions": ["lang"],
   "chapter": 21,
   "searchForm": "makros, -a, -on"
 },
 {
   "latin": "μάλ’",
   "info": "",
   "definitions": ["zeer, erg"],
   "chapter": 6,
   "searchForm": "mal’"
 },
 {
   "latin": "μάλα",
   "info": "",
   "definitions": ["zeer, erg"],
   "chapter": 6,
   "searchForm": "mala"
 },
 {
   "latin": "μάλιστα",
   "info": "bijw",
   "definitions": ["vooral, het meest"],
   "chapter": 17,
   "searchForm": "malista"
 },
 {
   "latin": "μᾶλλον",
   "info": "bijw",
   "definitions": ["meer, liever, eerder"],
   "chapter": 41,
   "searchForm": "mallon"
 },
 {
   "latin": "μανθάνω",
   "info": "",
   "definitions": ["leren (kennen), vernemen"],
   "chapter": 13,
   "searchForm": "manthano"
 },
 {
   "latin": "ἡ μανία",
   "info": "",
   "definitions": ["waanzin, razernij"],
   "chapter": 44,
   "searchForm": "mania"
 },
 {
   "latin": "μαρτυρέω",
   "info": "",
   "definitions": ["getuigenis afleggen"],
   "chapter": 44,
   "searchForm": "martureo"
 },
 {
   "latin": "ἡ μάχη",
   "info": "",
   "definitions": ["strijd, gevecht"],
   "chapter": 2,
   "searchForm": "mache"
 },
 {
   "latin": "μάχομαι",
   "info": "(+ dat)",
   "definitions": ["strijden (met/tegen)"],
   "chapter": 33,
   "searchForm": "machomai"
 },
 {
   "latin": "τὸ μέγαρον",
   "info": "",
   "definitions": ["(grote) kamer"],
   "chapter": 29,
   "searchForm": "megaron"
 },
 {
   "latin": "μέγας, μεγάλη, μέγα",
   "info": "",
   "definitions": ["groot"],
   "chapter": 21,
   "searchForm": "megas, megale, mega"
 },
 {
   "latin": "τὸ μέγεθος, -ους",
   "info": "",
   "definitions": ["grootte, grootheid"],
   "chapter": 43,
   "searchForm": "megethos, -ous"
 },
 {
   "latin": "μέγιστος, -η, -ον",
   "info": "",
   "definitions": ["het grootste, zeer groot"],
   "chapter": 24,
   "searchForm": "megistos, -e, -on"
 },
 {
   "latin": "μεθ’",
   "info": "+ gen",
   "definitions": ["(samen) met"],
   "chapter": 14,
   "searchForm": "meth’"
 },
 {
   "latin": "μεθ’",
   "info": "+ acc",
   "definitions": ["na"],
   "chapter": 23,
   "searchForm": "meth’"
 },
 {
   "latin": "μείζων, μείζονος",
   "info": "",
   "definitions": ["groter"],
   "chapter": 32,
   "searchForm": "meizon, meizonos"
 },
 {
   "latin": "μέλλω",
   "info": "",
   "definitions": ["zullen, van plan zijn, op het punt staan"],
   "chapter": 11,
   "searchForm": "mello"
 },
 {
   "latin": "μέν … δέ",
   "info": "",
   "definitions": ["(weliswaar) … maar", "… en"],
   "chapter": 3,
   "searchForm": "men … de"
 },
 {
   "latin": "μέντοι",
   "info": "",
   "definitions": ["echter, maar"],
   "chapter": 28,
   "searchForm": "mentoi"
 },
 {
   "latin": "μένω",
   "info": "",
   "definitions": ["blijven, wachten (op)"],
   "chapter": 12,
   "searchForm": "meno"
 },
 {
   "latin": "μέσος, -η, -ον",
   "info": "",
   "definitions": ["middelste", "*μέσος ὁ* … het midden van …"],
   "chapter": 42,
   "searchForm": "mesos, -e, -on"
 },
 {
   "latin": "μετ’",
   "info": "+ gen",
   "definitions": ["(samen) met"],
   "chapter": 14,
   "searchForm": "met’"
 },
 {
   "latin": "μετ’",
   "info": "+ acc",
   "definitions": ["na"],
   "chapter": 23,
   "searchForm": "met’"
 },
 {
   "latin": "μετά",
   "info": "+ gen",
   "definitions": ["(samen) met"],
   "chapter": 14,
   "searchForm": "meta"
 },
 {
   "latin": "μετά",
   "info": "+ acc",
   "definitions": ["na"],
   "chapter": 23,
   "searchForm": "meta"
 },
 {
   "latin": "μεταβάλλω",
   "info": "",
   "definitions": ["verplaatsen", "veranderen"],
   "chapter": 26,
   "searchForm": "metaballo"
 },
 {
   "latin": "μετέχω",
   "info": "",
   "definitions": ["deelnemen aan"],
   "chapter": 11,
   "searchForm": "metecho"
 },
 {
   "latin": "μέχρι",
   "info": "+ gen",
   "definitions": ["tot aan"],
   "chapter": 27,
   "searchForm": "mechri"
 },
 {
   "latin": "μή",
   "info": "+ con",
   "definitions": ["niet", "(op)dat niet", "**na ww van vrezen** dat"],
   "chapter": 41,
   "searchForm": "me"
 },
 {
   "latin": "μηδέ",
   "info": "+ con/opt",
   "definitions": ["en niet"],
   "chapter": 42,
   "searchForm": "mede"
 },
 {
   "latin": "ἡ μήτηρ, μητρός",
   "info": "",
   "definitions": ["moeder"],
   "chapter": 6,
   "searchForm": "meter, metros"
 },
 {
   "latin": "μικρός, -ά, -όν",
   "info": "",
   "definitions": ["klein"],
   "chapter": 24,
   "searchForm": "mikros, -a, -on"
 },
 {
   "latin": "ὁ μισθός",
   "info": "",
   "definitions": ["loon, soldij"],
   "chapter": 31,
   "searchForm": "misthos"
 },
 {
   "latin": "μόνον",
   "info": "bijw",
   "definitions": ["alleen (maar)"],
   "chapter": 6,
   "searchForm": "monon"
 },
 {
   "latin": "μόνος, -η, -ον",
   "info": "",
   "definitions": ["alleen"],
   "chapter": 29,
   "searchForm": "monos, -e, -on"
 },
 {
   "latin": "ὁ μῦθος",
   "info": "",
   "definitions": ["verhaal, mythe"],
   "chapter": 43,
   "searchForm": "muthos"
 },
 {
   "latin": "ὁ ναός",
   "info": "",
   "definitions": ["tempel"],
   "chapter": 43,
   "searchForm": "naos"
 },
 {
   "latin": "ἡ ναῦς, νεώς",
   "info": "",
   "definitions": ["schip"],
   "chapter": 36,
   "searchForm": "naus, neos"
 },
 {
   "latin": "ὁ ναύτης, ναύτου",
   "info": "",
   "definitions": ["zeeman"],
   "chapter": 23,
   "searchForm": "nautes, nautou"
 },
 {
   "latin": "ὁ νεανίας, -ου",
   "info": "",
   "definitions": ["jongeman"],
   "chapter": 34,
   "searchForm": "neanias, -ou"
 },
 {
   "latin": "ὁ νεκρός",
   "info": "",
   "definitions": ["dode, lijk"],
   "chapter": 27,
   "searchForm": "nekros"
 },
 {
   "latin": "νέμω",
   "info": "",
   "definitions": ["verdelen, toekennen"],
   "chapter": 18,
   "searchForm": "nemo"
 },
 {
   "latin": "νέος, -α, -ον",
   "info": "",
   "definitions": ["nieuw, jong"],
   "chapter": 21,
   "searchForm": "neos, -a, -on"
 },
 {
   "latin": "νικάω",
   "info": "",
   "definitions": ["overwinnen"],
   "chapter": 17,
   "searchForm": "nikao"
 },
 {
   "latin": "ἡ νίκη",
   "info": "",
   "definitions": ["overwinning"],
   "chapter": 13,
   "searchForm": "nike"
 },
 {
   "latin": "νοέω",
   "info": "",
   "definitions": ["waarnemen, opmerken"],
   "chapter": 3,
   "searchForm": "noeo"
 },
 {
   "latin": "νομίζω",
   "info": "",
   "definitions": ["menen", "beschouwen als"],
   "chapter": 13,
   "searchForm": "nomizo"
 },
 {
   "latin": "ὁ νόμος",
   "info": "",
   "definitions": ["gewoonte, gebruik", "wet"],
   "chapter": 18,
   "searchForm": "nomos"
 },
 {
   "latin": "ὁ νοῦς, νοῦ",
   "info": "",
   "definitions": ["geest, verstand"],
   "chapter": 37,
   "searchForm": "nous, nou"
 },
 {
   "latin": "νυκτός",
   "info": "gen",
   "definitions": ["s nachts"],
   "chapter": 31,
   "searchForm": "nuktos"
 },
 {
   "latin": "νῦν",
   "info": "bijw",
   "definitions": ["nu, op dit moment"],
   "chapter": 3,
   "searchForm": "nun"
 },
 {
   "latin": "ἡ νύξ, νυκτός",
   "info": "",
   "definitions": ["nacht"],
   "chapter": 21,
   "searchForm": "nux, nuktos"
 },
 {
   "latin": "ὁ ξένος ",
   "info": "",
   "definitions": ["vreemdeling", "gast", "gastheer"],
   "chapter": 28,
   "searchForm": "xenos "
 },
 {
   "latin": "τὸ ξύλον",
   "info": "",
   "definitions": ["(voorwerp van) hout"],
   "chapter": 34,
   "searchForm": "xulon"
 },
 {
   "latin": "οἷος, -α, -ον τ’ εἰμί",
   "info": "",
   "definitions": ["in staat zijn"],
   "chapter": 34,
   "searchForm": "hoios, -a, -on t’ eimi"
 },
 {
   "latin": "οὗ",
   "info": "voegwoord",
   "definitions": ["waar"],
   "chapter": 9,
   "searchForm": "hou"
 },
 {
   "latin": "οὗτος, αὕτη, τοῦτο",
   "info": "",
   "definitions": ["die, dat"],
   "chapter": 22,
   "searchForm": "houtos, haute, touto"
 },
 {
   "latin": "οὕτω",
   "info": "",
   "definitions": ["zo, op deze manier"],
   "chapter": 4,
   "searchForm": "houto"
 },
 {
   "latin": "οὕτως ",
   "info": "",
   "definitions": ["zo, op deze manier"],
   "chapter": 4,
   "searchForm": "houtos "
 },
 {
   "latin": "οἴκαδε",
   "info": "",
   "definitions": ["naar huis"],
   "chapter": 34,
   "searchForm": "oikade"
 },
 {
   "latin": "ὁ οἰκέτης, -ου",
   "info": "",
   "definitions": ["(huis)slaaf"],
   "chapter": 44,
   "searchForm": "oiketes, -ou"
 },
 {
   "latin": "οἰκέω",
   "info": "",
   "definitions": ["wonen, bewonen"],
   "chapter": 16,
   "searchForm": "oikeo"
 },
 {
   "latin": "ἡ οἰκία",
   "info": "",
   "definitions": ["huis"],
   "chapter": 28,
   "searchForm": "oikia"
 },
 {
   "latin": "ὁ οἶκος",
   "info": "",
   "definitions": ["huis, woning, erf"],
   "chapter": 11,
   "searchForm": "oikos"
 },
 {
   "latin": "ὁ οἶνος",
   "info": "",
   "definitions": ["wijn"],
   "chapter": 11,
   "searchForm": "oinos"
 },
 {
   "latin": "οἴομαι",
   "info": "",
   "definitions": ["menen, vermoeden"],
   "chapter": 31,
   "searchForm": "oiomai"
 },
 {
   "latin": "ὀλίγος, -η, -ον",
   "info": "",
   "definitions": ["weinig, gering"],
   "chapter": 27,
   "searchForm": "oligos, -e, -on"
 },
 {
   "latin": "τὸ ὄνομα, ὀνόματος",
   "info": "",
   "definitions": ["naam"],
   "chapter": 6,
   "searchForm": "onoma, onomatos"
 },
 {
   "latin": "ὀνομάζω",
   "info": "",
   "definitions": ["noemen"],
   "chapter": 3,
   "searchForm": "onomazo"
 },
 {
   "latin": "ὀξύς, -εῖα, -ύ",
   "info": "",
   "definitions": ["scherp, fel"],
   "chapter": 24,
   "searchForm": "oxus, -eia, -u"
 },
 {
   "latin": "ἡ ὀργή",
   "info": "",
   "definitions": ["woede, drift"],
   "chapter": 28,
   "searchForm": "orge"
 },
 {
   "latin": "ὀργίζομαι",
   "info": "(+ dat)",
   "definitions": ["boos worden (op/over)"],
   "chapter": 32,
   "searchForm": "orgizomai"
 },
 {
   "latin": "ὀργίζω",
   "info": "",
   "definitions": ["boos maken"],
   "chapter": 28,
   "searchForm": "orgizo"
 },
 {
   "latin": "τὸ ὄρος, -ους",
   "info": "",
   "definitions": ["berg, gebergte"],
   "chapter": 39,
   "searchForm": "oros, -ous"
 },
 {
   "latin": "οὐ",
   "info": "",
   "definitions": ["niet"],
   "chapter": 2,
   "searchForm": "ou"
 },
 {
   "latin": "οὐδαμοῦ",
   "info": "",
   "definitions": ["nergens"],
   "chapter": 37,
   "searchForm": "oudamou"
 },
 {
   "latin": "οὐδαμῶς",
   "info": "bijw",
   "definitions": ["volstrekt niet"],
   "chapter": 36,
   "searchForm": "oudamos"
 },
 {
   "latin": "οὐδέ",
   "info": "",
   "definitions": ["en niet, ook niet, maar niet", "zelfs niet"],
   "chapter": 24,
   "searchForm": "oude"
 },
 {
   "latin": "οὐδείς, οὐδενός",
   "info": "",
   "definitions": ["niemand"],
   "chapter": 17,
   "searchForm": "oudeis, oudenos"
 },
 {
   "latin": "οὐδέν, οὐδενός",
   "info": "",
   "definitions": ["niets"],
   "chapter": 17,
   "searchForm": "ouden, oudenos"
 },
 {
   "latin": "οὐκ",
   "info": "",
   "definitions": ["niet"],
   "chapter": 2,
   "searchForm": "ouk"
 },
 {
   "latin": "οὐκέτι",
   "info": "bijw",
   "definitions": ["niet meer"],
   "chapter": 9,
   "searchForm": "ouketi"
 },
 {
   "latin": "οὖν",
   "info": "",
   "definitions": ["dus, dan, nu"],
   "chapter": 4,
   "searchForm": "oun"
 },
 {
   "latin": "οὔποτε",
   "info": "",
   "definitions": ["nooit"],
   "chapter": 11,
   "searchForm": "oupote"
 },
 {
   "latin": "οὔπω",
   "info": "",
   "definitions": ["nog niet"],
   "chapter": 27,
   "searchForm": "oupo"
 },
 {
   "latin": "ὁ οὐρανός",
   "info": "",
   "definitions": ["hemel"],
   "chapter": 21,
   "searchForm": "ouranos"
 },
 {
   "latin": "οὐχ",
   "info": "",
   "definitions": ["niet"],
   "chapter": 2,
   "searchForm": "ouch"
 },
 {
   "latin": "ὀφείλω",
   "info": "+ inf",
   "definitions": ["verplicht zijn te"],
   "chapter": 13,
   "searchForm": "ofeilo"
 },
 {
   "latin": "ὁ ὀφθαλμός",
   "info": "",
   "definitions": ["oog"],
   "chapter": 24,
   "searchForm": "ofthalmos"
 },
 {
   "latin": "παιδεύω",
   "info": "",
   "definitions": ["opvoeden, opleiden"],
   "chapter": 38,
   "searchForm": "paideuo"
 },
 {
   "latin": "ὁ/ἡ παῖς, παιδός",
   "info": "",
   "definitions": ["kind"],
   "chapter": 7,
   "searchForm": "ho/pais, paidos"
 },
 {
   "latin": "πανταχοῦ",
   "info": "",
   "definitions": ["overal"],
   "chapter": 32,
   "searchForm": "pantachou"
 },
 {
   "latin": "πάντως",
   "info": "bijw",
   "definitions": ["geheel en al, volledig"],
   "chapter": 37,
   "searchForm": "pantos"
 },
 {
   "latin": "πάνυ",
   "info": "bijw",
   "definitions": ["heel, zeker, volkomen"],
   "chapter": 37,
   "searchForm": "panu"
 },
 {
   "latin": "πάρ-ειμι",
   "info": "",
   "definitions": ["aanwezig zijn"],
   "chapter": 14,
   "searchForm": "par-eimi"
 },
 {
   "latin": "παρ’",
   "info": "+ dat",
   "definitions": ["bij, naast"],
   "chapter": 29,
   "searchForm": "par’"
 },
 {
   "latin": "παρά",
   "info": "+ gen",
   "definitions": ["van (de kant van)"],
   "chapter": 23,
   "searchForm": "para"
 },
 {
   "latin": "παρά",
   "info": "+ dat",
   "definitions": ["bij, naast"],
   "chapter": 29,
   "searchForm": "para"
 },
 {
   "latin": "παραγίγνομαι",
   "info": "+ dat",
   "definitions": ["komen bij", "bijstaan"],
   "chapter": 42,
   "searchForm": "paragignomai"
 },
 {
   "latin": "παραινέω",
   "info": "+ dat",
   "definitions": ["aansporen"],
   "chapter": 38,
   "searchForm": "paraineo"
 },
 {
   "latin": "παρακαλέω",
   "info": "",
   "definitions": ["erbij roepen, laten komen"],
   "chapter": 42,
   "searchForm": "parakaleo"
 },
 {
   "latin": "παρασκευάζω",
   "info": "",
   "definitions": ["klaarmaken"],
   "chapter": 9,
   "searchForm": "paraskeuazo"
 },
 {
   "latin": "παρέχω",
   "info": "",
   "definitions": ["geven, verschaffen"],
   "chapter": 7,
   "searchForm": "parecho"
 },
 {
   "latin": "ἡ παρθένος",
   "info": "",
   "definitions": ["maagd, ongetrouwde vrouw"],
   "chapter": 43,
   "searchForm": "parthenos"
 },
 {
   "latin": "πᾶς, πᾶσα, πᾶν, παντός",
   "info": "",
   "definitions": ["**ev** ieder, elk<br>2.* *ev** (ge)heel, al", "**mv** alle(n), alles"],
   "chapter": 23,
   "searchForm": "pas, pasa, pan, pantos"
 },
 {
   "latin": "πάσχω",
   "info": "",
   "definitions": ["lijden, ondervinden"],
   "chapter": 13,
   "searchForm": "pascho"
 },
 {
   "latin": "ὁ πατήρ, πατρός",
   "info": "",
   "definitions": ["vader"],
   "chapter": 6,
   "searchForm": "pater, patros"
 },
 {
   "latin": "παύομαι",
   "info": "",
   "definitions": ["**+ gen** ophouden met", "**+ ptc prs** ophouden te/met"],
   "chapter": 32,
   "searchForm": "pauomai"
 },
 {
   "latin": "παύω",
   "info": "",
   "definitions": ["doen stoppen, een einde maken aan"],
   "chapter": 21,
   "searchForm": "pauo"
 },
 {
   "latin": "τὸ πεδίον",
   "info": "",
   "definitions": ["vlakte"],
   "chapter": 3,
   "searchForm": "pedion"
 },
 {
   "latin": "πείθομαι",
   "info": "(+ dat)",
   "definitions": ["gehoorzamen, geloven"],
   "chapter": 31,
   "searchForm": "peithomai"
 },
 {
   "latin": "πείθω",
   "info": "",
   "definitions": ["overtuigen, overhalen"],
   "chapter": 19,
   "searchForm": "peitho"
 },
 {
   "latin": "πειράομαι",
   "info": "",
   "definitions": ["proberen"],
   "chapter": 44,
   "searchForm": "peiraomai"
 },
 {
   "latin": "πέμπω",
   "info": "",
   "definitions": ["zenden, sturen"],
   "chapter": 9,
   "searchForm": "pempo"
 },
 {
   "latin": "πέντε",
   "info": "telwoord",
   "definitions": ["vijf"],
   "chapter": 42,
   "searchForm": "pente"
 },
 {
   "latin": "περί",
   "info": "+ gen",
   "definitions": ["over, om"],
   "chapter": 9,
   "searchForm": "peri"
 },
 {
   "latin": "περί",
   "info": "+ acc",
   "definitions": ["rondom, om"],
   "chapter": 13,
   "searchForm": "peri"
 },
 {
   "latin": "ἡ πέτρα",
   "info": "",
   "definitions": ["rots, rotsblok"],
   "chapter": 2,
   "searchForm": "petra"
 },
 {
   "latin": "πίνω",
   "info": "",
   "definitions": ["drinken"],
   "chapter": 11,
   "searchForm": "pino"
 },
 {
   "latin": "πίπτω",
   "info": "",
   "definitions": ["vallen"],
   "chapter": 13,
   "searchForm": "pipto"
 },
 {
   "latin": "πιστεύω",
   "info": "+ dat",
   "definitions": ["geloven, vertrouwen op"],
   "chapter": 14,
   "searchForm": "pisteuo"
 },
 {
   "latin": "πλεῖστος, -η, -ον",
   "info": "",
   "definitions": ["meest, zeer veel"],
   "chapter": 39,
   "searchForm": "pleistos, -e, -on"
 },
 {
   "latin": "πλέω",
   "info": "",
   "definitions": ["varen"],
   "chapter": 36,
   "searchForm": "pleo"
 },
 {
   "latin": "τὸ πλῆθος, -ους",
   "info": "",
   "definitions": ["menigte, massa"],
   "chapter": 42,
   "searchForm": "plethos, -ous"
 },
 {
   "latin": "πλήν",
   "info": "+ gen",
   "definitions": ["behalve, afgezien van"],
   "chapter": 28,
   "searchForm": "plen"
 },
 {
   "latin": "τὸ πλοῖον",
   "info": "",
   "definitions": ["vaartuig, schip"],
   "chapter": 8,
   "searchForm": "ploion"
 },
 {
   "latin": "πλούσιος, -α, -ον",
   "info": "",
   "definitions": ["rijk"],
   "chapter": 37,
   "searchForm": "plousios, -a, -on"
 },
 {
   "latin": "τὸ πνεῦμα, πνεύματος",
   "info": "",
   "definitions": ["lucht, adem"],
   "chapter": 16,
   "searchForm": "pneuma, pneumatos"
 },
 {
   "latin": "ποιέω",
   "info": "",
   "definitions": ["maken, doen"],
   "chapter": 8,
   "searchForm": "poieo"
 },
 {
   "latin": "ποῖος, -α, -ον",
   "info": "",
   "definitions": ["hoedanig, wat voor"],
   "chapter": 43,
   "searchForm": "poios, -a, -on"
 },
 {
   "latin": "πολεμέω",
   "info": "(+ dat)",
   "definitions": ["oorlog voeren (tegen)"],
   "chapter": 17,
   "searchForm": "polemeo"
 },
 {
   "latin": "ὁ πολέμιος",
   "info": "",
   "definitions": ["vijand"],
   "chapter": 39,
   "searchForm": "polemios"
 },
 {
   "latin": "πολέμιος, -α, -ον",
   "info": "",
   "definitions": ["vijandig"],
   "chapter": 39,
   "searchForm": "polemios, -a, -on"
 },
 {
   "latin": "ὁ πόλεμος",
   "info": "",
   "definitions": ["oorlog"],
   "chapter": 13,
   "searchForm": "polemos"
 },
 {
   "latin": "ἡ πόλις, πόλεως",
   "info": "",
   "definitions": ["stad, stadstaat"],
   "chapter": 36,
   "searchForm": "polis, poleos"
 },
 {
   "latin": "ὁ πολίτης, -ου",
   "info": "",
   "definitions": ["burger, medeburger"],
   "chapter": 34,
   "searchForm": "polites, -ou"
 },
 {
   "latin": "πολιτικός, -ή, -όν",
   "info": "",
   "definitions": ["de burger(s) betreffend, politiek"],
   "chapter": 41,
   "searchForm": "politikos, -e, -on"
 },
 {
   "latin": "πολλάκις",
   "info": "",
   "definitions": ["vaak"],
   "chapter": 16,
   "searchForm": "pollakis"
 },
 {
   "latin": "πολύ",
   "info": "bijw",
   "definitions": ["veel"],
   "chapter": 32,
   "searchForm": "polu"
 },
 {
   "latin": "πολύς, πολλή, πολύ",
   "info": "",
   "definitions": ["veel"],
   "chapter": 21,
   "searchForm": "polus, polle, polu"
 },
 {
   "latin": "πονέω",
   "info": "",
   "definitions": ["werken, zich inspannen", "pijn hebben, het zwaar hebben"],
   "chapter": 38,
   "searchForm": "poneo"
 },
 {
   "latin": "ὁ πόνος",
   "info": "",
   "definitions": ["inspanning, moeite", "pijn, nood"],
   "chapter": 36,
   "searchForm": "ponos"
 },
 {
   "latin": "πορεύομαι",
   "info": "",
   "definitions": ["reizen"],
   "chapter": 42,
   "searchForm": "poreuomai"
 },
 {
   "latin": "ὁ ποταμός  ",
   "info": "",
   "definitions": ["rivier"],
   "chapter": 2,
   "searchForm": "potamos  "
 },
 {
   "latin": "ποτε",
   "info": "bijw",
   "definitions": ["eens, ooit"],
   "chapter": 14,
   "searchForm": "pote"
 },
 {
   "latin": "ποτός, -ή, -όν",
   "info": "",
   "definitions": ["drinkbaar"],
   "chapter": 43,
   "searchForm": "potos, -e, -on"
 },
 {
   "latin": "ὁ πούς, ποδός",
   "info": "",
   "definitions": ["voet"],
   "chapter": 21,
   "searchForm": "pous, podos"
 },
 {
   "latin": "τὸ πρᾶγμα, πράγματος",
   "info": "",
   "definitions": ["zaak, gebeurtenis"],
   "chapter": 6,
   "searchForm": "pragma, pragmatos"
 },
 {
   "latin": "πράττω",
   "info": "",
   "definitions": ["doen, handelen"],
   "chapter": 11,
   "searchForm": "pratto"
 },
 {
   "latin": "πρό",
   "info": "+ gen",
   "definitions": ["voor (*tijd en plaats*)"],
   "chapter": 42,
   "searchForm": "pro"
 },
 {
   "latin": "προάγω",
   "info": "",
   "definitions": ["(naar voren) leiden, verder leiden"],
   "chapter": 42,
   "searchForm": "proago"
 },
 {
   "latin": "πρός",
   "info": "+ acc",
   "definitions": ["naar (toe), tot, tegen"],
   "chapter": 4,
   "searchForm": "pros"
 },
 {
   "latin": "πρός",
   "info": "+ dat",
   "definitions": ["tegen … aan, dichtbij"],
   "chapter": 18,
   "searchForm": "pros"
 },
 {
   "latin": "προσαγορεύω",
   "info": "",
   "definitions": ["begroeten, aanspreken"],
   "chapter": 28,
   "searchForm": "prosagoreuo"
 },
 {
   "latin": "προσέρχομαι",
   "info": "(+ dat)",
   "definitions": ["naderen"],
   "chapter": 39,
   "searchForm": "proserchomai"
 },
 {
   "latin": "προσέχω",
   "info": "",
   "definitions": ["richten op"],
   "chapter": 29,
   "searchForm": "prosecho"
 },
 {
   "latin": "προστάττω",
   "info": "(+ dat + inf)",
   "definitions": ["(iemand) opdragen (om)"],
   "chapter": 38,
   "searchForm": "prostatto"
 },
 {
   "latin": "τὸ πρόσωπον",
   "info": "",
   "definitions": ["gezicht"],
   "chapter": 32,
   "searchForm": "prosopon"
 },
 {
   "latin": "πρότερον",
   "info": "bijw",
   "definitions": ["eerder"],
   "chapter": 37,
   "searchForm": "proteron"
 },
 {
   "latin": "πρῶτον",
   "info": "bijw",
   "definitions": ["eerst"],
   "chapter": 2,
   "searchForm": "proton"
 },
 {
   "latin": "πρῶτος, -η, -ον",
   "info": "",
   "definitions": ["eerste"],
   "chapter": 29,
   "searchForm": "protos, -e, -on"
 },
 {
   "latin": "πυνθάνομαι",
   "info": "",
   "definitions": ["vernemen", "**prs** vragen naar, informeren naar"],
   "chapter": 34,
   "searchForm": "punthanomai"
 },
 {
   "latin": "τὸ πῦρ, πυρός",
   "info": "",
   "definitions": ["vuur"],
   "chapter": 6,
   "searchForm": "pur, puros"
 },
 {
   "latin": "πωλέω",
   "info": "",
   "definitions": ["verkopen"],
   "chapter": 37,
   "searchForm": "poleo"
 },
 {
   "latin": "πῶς",
   "info": "",
   "definitions": ["hoe"],
   "chapter": 11,
   "searchForm": "pos"
 },
 {
   "latin": "ῥᾴδιος, -α, -ον",
   "info": "",
   "definitions": ["gemakkelijk"],
   "chapter": 37,
   "searchForm": "rhaidios, -a, -on"
 },
 {
   "latin": "ῥέω",
   "info": "",
   "definitions": ["stromen"],
   "chapter": 16,
   "searchForm": "rheo"
 },
 {
   "latin": "ῥίπτω",
   "info": "",
   "definitions": ["werpen"],
   "chapter": 23,
   "searchForm": "rhipto"
 },
 {
   "latin": "σαφής, -ές",
   "info": "",
   "definitions": ["duidelijk"],
   "chapter": 37,
   "searchForm": "safes, -es"
 },
 {
   "latin": "σέ",
   "info": "",
   "definitions": ["je"],
   "chapter": 8,
   "searchForm": "se"
 },
 {
   "latin": "ἡ σελήνη",
   "info": "",
   "definitions": ["maan"],
   "chapter": 36,
   "searchForm": "selene"
 },
 {
   "latin": "σημαίνω",
   "info": "",
   "definitions": ["duidelijk maken, markeren", "betekenen"],
   "chapter": 29,
   "searchForm": "semaino"
 },
 {
   "latin": "ὁ σῖτος",
   "info": "",
   "definitions": ["graan, brood", "voedsel"],
   "chapter": 28,
   "searchForm": "sitos"
 },
 {
   "latin": "σκοπέω",
   "info": "",
   "definitions": ["bekijken, beschouwen"],
   "chapter": 16,
   "searchForm": "skopeo"
 },
 {
   "latin": "σοί",
   "info": "",
   "definitions": ["aan/voor jou"],
   "chapter": 8,
   "searchForm": "soi"
 },
 {
   "latin": "σός, σή, σόν",
   "info": "",
   "definitions": ["jouw, uw"],
   "chapter": 21,
   "searchForm": "sos, se, son"
 },
 {
   "latin": "σοῦ",
   "info": "",
   "definitions": ["van jou"],
   "chapter": 8,
   "searchForm": "sou"
 },
 {
   "latin": "ἡ σοφία",
   "info": "",
   "definitions": ["(vak)kennis, wijsheid"],
   "chapter": 8,
   "searchForm": "sofia"
 },
 {
   "latin": "σοφός, -ή, -όν",
   "info": "",
   "definitions": ["wijs, verstandig"],
   "chapter": 21,
   "searchForm": "sofos, -e, -on"
 },
 {
   "latin": "ἡ σπουδή",
   "info": "",
   "definitions": ["serieuze inspanning", "haast"],
   "chapter": 36,
   "searchForm": "spoude"
 },
 {
   "latin": "ὁ στόλος",
   "info": "",
   "definitions": ["reis, expeditie"],
   "chapter": 8,
   "searchForm": "stolos"
 },
 {
   "latin": "τὸ στόμα, στόματος",
   "info": "",
   "definitions": ["mond"],
   "chapter": 24,
   "searchForm": "stoma, stomatos"
 },
 {
   "latin": "στρατεύομαι",
   "info": "",
   "definitions": ["een veldtocht ondernemen, optrekken"],
   "chapter": 39,
   "searchForm": "strateuomai"
 },
 {
   "latin": "ὁ στρατηγός",
   "info": "",
   "definitions": ["veldheer, aanvoerder"],
   "chapter": 39,
   "searchForm": "strategos"
 },
 {
   "latin": "ἡ στρατιά",
   "info": "",
   "definitions": ["leger"],
   "chapter": 19,
   "searchForm": "stratia"
 },
 {
   "latin": "ὁ στρατιώτης, -ου",
   "info": "",
   "definitions": ["soldaat"],
   "chapter": 39,
   "searchForm": "stratiotes, -ou"
 },
 {
   "latin": "σύ",
   "info": "",
   "definitions": ["jij"],
   "chapter": 8,
   "searchForm": "su"
 },
 {
   "latin": "(ὁ) συγγενής, -ές",
   "info": "",
   "definitions": ["verwant"],
   "chapter": 42,
   "searchForm": "suggenes, -es"
 },
 {
   "latin": "συλλέγω",
   "info": "",
   "definitions": ["verzamelen"],
   "chapter": 26,
   "searchForm": "sullego"
 },
 {
   "latin": "συμβουλεύω",
   "info": "",
   "definitions": ["raad geven", "**+ inf** aanraden om"],
   "chapter": 17,
   "searchForm": "sumbouleuo"
 },
 {
   "latin": "ὁ σύμμαχος",
   "info": "",
   "definitions": ["bondgenoot"],
   "chapter": 39,
   "searchForm": "summachos"
 },
 {
   "latin": "σύν",
   "info": "+ dat",
   "definitions": ["met"],
   "chapter": 8,
   "searchForm": "sun"
 },
 {
   "latin": "συν-",
   "info": "voorvoegsel",
   "definitions": ["bijeen-, samen-"],
   "chapter": 41,
   "searchForm": "sun-"
 },
 {
   "latin": "σφόδρα",
   "info": "",
   "definitions": ["hevig, zeer, erg"],
   "chapter": 16,
   "searchForm": "sfodra"
 },
 {
   "latin": "σῴζω",
   "info": "",
   "definitions": ["redden"],
   "chapter": 11,
   "searchForm": "soizo"
 },
 {
   "latin": "τὸ σῶμα, σώματος",
   "info": "",
   "definitions": ["lichaam"],
   "chapter": 13,
   "searchForm": "soma, somatos"
 },
 {
   "latin": "τὰ ὅπλα",
   "info": "mv",
   "definitions": ["wapens"],
   "chapter": 6,
   "searchForm": "hopla"
 },
 {
   "latin": "ἡ τάξις, -εως",
   "info": "",
   "definitions": ["slagorde, opstelling", "legereenheid"],
   "chapter": 39,
   "searchForm": "taxis, -eos"
 },
 {
   "latin": "τάττω",
   "info": "",
   "definitions": ["opstellen, ordenen"],
   "chapter": 18,
   "searchForm": "tatto"
 },
 {
   "latin": "ὁ ταῦρος",
   "info": "",
   "definitions": ["stier"],
   "chapter": 34,
   "searchForm": "tauros"
 },
 {
   "latin": "ὁ τάφος",
   "info": "",
   "definitions": ["graf", "begrafenis"],
   "chapter": 29,
   "searchForm": "tafos"
 },
 {
   "latin": "τάχα",
   "info": "",
   "definitions": ["snel, spoedig"],
   "chapter": 11,
   "searchForm": "tacha"
 },
 {
   "latin": "ταχύς, -εῖα, -ύ",
   "info": "",
   "definitions": ["snel"],
   "chapter": 23,
   "searchForm": "tachus, -eia, -u"
 },
 {
   "latin": "τε … καί",
   "info": "",
   "definitions": ["en"],
   "chapter": 21,
   "searchForm": "te … kai"
 },
 {
   "latin": "τε καί",
   "info": "",
   "definitions": ["en"],
   "chapter": 21,
   "searchForm": "te kai"
 },
 {
   "latin": "τὸ τέκνον",
   "info": "",
   "definitions": ["kind"],
   "chapter": 4,
   "searchForm": "teknon"
 },
 {
   "latin": "τελέω",
   "info": "",
   "definitions": ["voltooien, afmaken"],
   "chapter": 19,
   "searchForm": "teleo"
 },
 {
   "latin": "τέλος",
   "info": "bijw",
   "definitions": ["tenslotte"],
   "chapter": 4,
   "searchForm": "telos"
 },
 {
   "latin": "τέμνω",
   "info": "",
   "definitions": ["snijden"],
   "chapter": 36,
   "searchForm": "temno"
 },
 {
   "latin": "τέτταρες, -α",
   "info": "mv",
   "definitions": ["vier"],
   "chapter": 24,
   "searchForm": "tettares, -a"
 },
 {
   "latin": "ἡ τέχνη",
   "info": "",
   "definitions": ["kunst, vaardigheid"],
   "chapter": 6,
   "searchForm": "techne"
 },
 {
   "latin": "τί",
   "info": "",
   "definitions": ["wat (*nom/acc*)", "waarom"],
   "chapter": 16,
   "searchForm": "ti"
 },
 {
   "latin": "τίκτω",
   "info": "",
   "definitions": ["ter wereld brengen, voortbrengen"],
   "chapter": 4,
   "searchForm": "tikto"
 },
 {
   "latin": "τιμάω",
   "info": "",
   "definitions": ["eren, vereren"],
   "chapter": 16,
   "searchForm": "timao"
 },
 {
   "latin": "ἡ τιμή",
   "info": "",
   "definitions": ["eer, aanzien"],
   "chapter": 8,
   "searchForm": "time"
 },
 {
   "latin": "τίς, τί, τίνος",
   "info": "",
   "definitions": ["**zelfst** wie, wat", "**bijv** welk(e)"],
   "chapter": 38,
   "searchForm": "tis, ti, tinos"
 },
 {
   "latin": "τις, τι, τινος",
   "info": "",
   "definitions": ["**zelfst** iemand, iets", "**bijv** een of ander(e), bepaalde"],
   "chapter": 38,
   "searchForm": "tis, ti, tinos"
 },
 {
   "latin": "τό",
   "info": "",
   "definitions": ["de, het"],
   "chapter": 2,
   "searchForm": "to"
 },
 {
   "latin": "τολμάω",
   "info": "+ inf",
   "definitions": ["het wagen om, durven"],
   "chapter": 41,
   "searchForm": "tolmao"
 },
 {
   "latin": "ὁ τόπος",
   "info": "",
   "definitions": ["plaats"],
   "chapter": 29,
   "searchForm": "topos"
 },
 {
   "latin": "τότε",
   "info": "bijw",
   "definitions": ["dan, toen, op dat moment"],
   "chapter": 2,
   "searchForm": "tote"
 },
 {
   "latin": "τρεῖς, τρία",
   "info": "",
   "definitions": ["drie"],
   "chapter": 36,
   "searchForm": "treis, tria"
 },
 {
   "latin": "τρέπω",
   "info": "",
   "definitions": ["wenden, keren"],
   "chapter": 12,
   "searchForm": "trepo"
 },
 {
   "latin": "τρεχω",
   "info": "",
   "definitions": ["rennen"],
   "chapter": 13,
   "searchForm": "trecho"
 },
 {
   "latin": "τυγχάνω",
   "info": "+ gen",
   "definitions": ["treffen, raken", "krijgen"],
   "chapter": 12,
   "searchForm": "tugchano"
 },
 {
   "latin": "τύπτω",
   "info": "",
   "definitions": ["slaan"],
   "chapter": 32,
   "searchForm": "tupto"
 },
 {
   "latin": "ἡ τύχη",
   "info": "",
   "definitions": ["lot, kans", "geluk", "ongeluk"],
   "chapter": 17,
   "searchForm": "tuche"
 },
 {
   "latin": "ὁ υἱός",
   "info": "",
   "definitions": ["zoon"],
   "chapter": 4,
   "searchForm": "huios"
 },
 {
   "latin": "φαίνομαι",
   "info": "",
   "definitions": ["zich tonen, verschijnen", "schijnen, lijken *(+ inf)*"],
   "chapter": 32,
   "searchForm": "fainomai"
 },
 {
   "latin": "φαίνω",
   "info": "",
   "definitions": ["laten zien, tonen"],
   "chapter": 7,
   "searchForm": "faino"
 },
 {
   "latin": "φανερός, -ά, -όν",
   "info": "",
   "definitions": ["duidelijk, zichtbaar"],
   "chapter": 36,
   "searchForm": "faneros, -a, -on"
 },
 {
   "latin": "φέρω",
   "info": "",
   "definitions": ["dragen, brengen"],
   "chapter": 3,
   "searchForm": "fero"
 },
 {
   "latin": "φεύγω",
   "info": "",
   "definitions": ["vluchten, ontvluchten"],
   "chapter": 7,
   "searchForm": "feugo"
 },
 {
   "latin": "φιλέω",
   "info": "",
   "definitions": ["**+ acc** houden van", "**+ inf** ervan houden om"],
   "chapter": 41,
   "searchForm": "fileo"
 },
 {
   "latin": "ὁ φίλος",
   "info": "",
   "definitions": ["vriend"],
   "chapter": 8,
   "searchForm": "filos"
 },
 {
   "latin": "φίλος, -η, -ον",
   "info": "",
   "definitions": ["geliefd, dierbaar"],
   "chapter": 21,
   "searchForm": "filos, -e, -on"
 },
 {
   "latin": "ὁ φιλόσοφος",
   "info": "",
   "definitions": ["wijsgeer, filosoof"],
   "chapter": 29,
   "searchForm": "filosofos"
 },
 {
   "latin": "φοβέομαι",
   "info": "",
   "definitions": ["bang zijn, vrezen"],
   "chapter": 31,
   "searchForm": "fobeomai"
 },
 {
   "latin": "φοβερός, -ά, -όν",
   "info": "",
   "definitions": ["angstaanjagend"],
   "chapter": 29,
   "searchForm": "foberos, -a, -on"
 },
 {
   "latin": "φοβέω",
   "info": "",
   "definitions": ["bang maken"],
   "chapter": 29,
   "searchForm": "fobeo"
 },
 {
   "latin": "ὁ φόβος",
   "info": "",
   "definitions": ["angst"],
   "chapter": 7,
   "searchForm": "fobos"
 },
 {
   "latin": "φράζω",
   "info": "",
   "definitions": ["vertellen, meedelen"],
   "chapter": 42,
   "searchForm": "frazo"
 },
 {
   "latin": "φρονέω",
   "info": "",
   "definitions": ["verstandig zijn, denken"],
   "chapter": 43,
   "searchForm": "froneo"
 },
 {
   "latin": "φροντίζω",
   "info": "+ gen",
   "definitions": ["bezig zijn met, zorgen voor"],
   "chapter": 44,
   "searchForm": "frontizo"
 },
 {
   "latin": "φυλάττω",
   "info": "",
   "definitions": ["bewaken", "beschermen"],
   "chapter": 14,
   "searchForm": "fulatto"
 },
 {
   "latin": "φύομαι",
   "info": "",
   "definitions": ["groeien"],
   "chapter": 36,
   "searchForm": "fuomai"
 },
 {
   "latin": "φύω",
   "info": "",
   "definitions": ["laten groeien, ontstaan"],
   "chapter": 26,
   "searchForm": "fuo"
 },
 {
   "latin": "τὸ φῶς, φωτός",
   "info": "",
   "definitions": ["(dag)licht"],
   "chapter": 6,
   "searchForm": "fos, fotos"
 },
 {
   "latin": "χαίρω",
   "info": "",
   "definitions": ["blij zijn"],
   "chapter": 7,
   "searchForm": "chairo"
 },
 {
   "latin": "χαλεπός, -ή, -όν",
   "info": "",
   "definitions": ["moeilijk, lastig"],
   "chapter": 22,
   "searchForm": "chalepos, -e, -on"
 },
 {
   "latin": "ὁ χειμών, χειμῶνος",
   "info": "",
   "definitions": ["winter", "storm"],
   "chapter": 26,
   "searchForm": "cheimon, cheimonos"
 },
 {
   "latin": "ἡ χείρ, χειρός",
   "info": "",
   "definitions": ["hand, arm"],
   "chapter": 26,
   "searchForm": "cheir, cheiros"
 },
 {
   "latin": "χρή",
   "info": "",
   "definitions": ["**+ gen** er is behoefte aan", "**+ aci** het is nodig dat"],
   "chapter": 41,
   "searchForm": "chre"
 },
 {
   "latin": "τὸ χρῆμα, χρηματος ",
   "info": "",
   "definitions": ["zaak, ding", "**mv** geld, bezit"],
   "chapter": 23,
   "searchForm": "chrema, chrematos "
 },
 {
   "latin": "χρήομαι",
   "info": "+ dat",
   "definitions": ["gebruiken, omgaan met"],
   "chapter": 31,
   "searchForm": "chreomai"
 },
 {
   "latin": "χρήσιμος, -ον",
   "info": "",
   "definitions": ["bruikbaar, nuttig"],
   "chapter": 43,
   "searchForm": "chresimos, -on"
 },
 {
   "latin": "ὁ χρόνος",
   "info": "",
   "definitions": ["tijd, periode"],
   "chapter": 23,
   "searchForm": "chronos"
 },
 {
   "latin": "ἡ χώρα",
   "info": "",
   "definitions": ["gebied, plaats"],
   "chapter": 7,
   "searchForm": "chora"
 },
 {
   "latin": "ψεύδω",
   "info": "",
   "definitions": ["bedriegen"],
   "chapter": 17,
   "searchForm": "pseudo"
 },
 {
   "latin": "ἡ ψῆφος",
   "info": "",
   "definitions": ["stem(steen)"],
   "chapter": 44,
   "searchForm": "psefos"
 },
 {
   "latin": "ἡ ψυχή",
   "info": "",
   "definitions": ["leven, ziel", "geest, schim"],
   "chapter": 26,
   "searchForm": "psuche"
 },
 {
   "latin": "ὦ",
   "info": "",
   "definitions": ["o (*aanhef, meestal niet vertalen*)"],
   "chapter": 8,
   "searchForm": "o"
 },
 {
   "latin": "ὤν, οὖσα, ὄν, ὄντος",
   "info": "",
   "definitions": ["*ptc prs van εἰμί*"],
   "chapter": 26,
   "searchForm": "on, ousa, on, ontos"
 }
]


module.exports = dictionaryData



// WEBPACK FOOTER //
// ./src/apps/lexikon/data/words.js